// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import ApiUrl from "../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext";

// function UpdateRetailer({ toggleSidebar }) {
//   const { id } = useParams();
//   const toast = useToast();
//   const navigate = useNavigate();
//   const [showModal, setShowModal] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [typeGetting, setTypeGetting] = useState([]);
//   const [supplierGetting, setSupplierGetting] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedSupplier, setSelectedSupplier] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [editingItemId, setEditingItemId] = useState(null);

//   const [updateData, setUpdateData] = useState({
//     retailer_id: "",
//     retailer_date: "",
//     supplier_id: "",
//     return_type: "Pure",
//     pure: "",
//     opening: "0",
//     current: "0",
//     close: "0",
//     initial_close: "0", // To store API's close value
//     total_pure: "0",
//     total_amount: "0",
//     items: [],
//     supplier_details: {
//       supplier_id: "",
//       name: null,
//       mobile: null,
//       address: null,
//     },
//   });

//   const [newItem, setNewItem] = useState({
//     item: "",
//     category: "",
//     other_name: "",
//     type: "",
//     quantity: "",
//     weight: "",
//     purity: "",
//     pure: "",
//     total_amount: "",
//   });

//   // Fetch product types
//   const fetchProductType = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/product_type.php`);
//       setTypeGetting(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching product types:", error.message);
//       setTypeGetting([]);
//       toast.error("Failed to load product types", 3000, "topRight");
//     }
//   };

//   // Fetch suppliers
//   const fetchSupplierType = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/supplier.php`);
//       setSupplierGetting(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching suppliers:", error.message);
//       setSupplierGetting([]);
//       toast.error("Failed to load suppliers", 3000, "topRight");
//     }
//   };

//   // Fetch retailer data by ID
//   const fetchRetailerData = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${ApiUrl}/Api/retailer_details.php/${id}`
//       );
//       if (!response.data || !Array.isArray(response.data.data)) {
//         throw new Error("Invalid response format");
//       }

//       const retailer = response.data.data.find((r) => r.id === id);
//       if (!retailer) {
//         throw new Error(`Retailer with ID ${id} not found`);
//       }

//       const formattedItems = Array.isArray(retailer.items)
//         ? retailer.items.map((item, index) => {
//             const weight = parseFloat(item.weight || 0);
//             const purity = parseFloat(item.percentage || item.purity || 0);
//             const quantity = parseFloat(item.quantity || 0);
//             const pure =
//               !isNaN(weight) && !isNaN(purity)
//                 ? ((weight * purity) / 100).toFixed(3)
//                 : "0.000";
//             const total_amount =
//               !isNaN(weight) && !isNaN(quantity)
//                 ? (quantity * weight).toFixed(3)
//                 : "0.000";
//             return {
//               id: item.id || (index + 1).toString(),
//               retailer_id: retailer.retailer_id || "",
//               item: item.item_name || item.item || "",
//               category: item.category || "",
//               other_name: item.other_name || "",
//               type: item.type || "",
//               quantity: item.quantity || "",
//               weight: item.weight || "",
//               purity: item.percentage || item.purity || "",
//               pure,
//               total_amount,
//             };
//           })
//         : [];

//       const totalPure = formattedItems
//         .reduce((sum, item) => sum + parseFloat(item.pure || 0), 0)
//         .toFixed(3);

//       const totalAmount = formattedItems
//         .reduce((sum, item) => sum + parseFloat(item.total_amount || 0), 0)
//         .toFixed(3);

//       const opening = parseFloat(retailer.opening || 0).toFixed(3);
//       const current = parseFloat(retailer.current || 0).toFixed(3);
//       const initialClose = parseFloat(retailer.close || 0).toFixed(3);
//       const pure = parseFloat(retailer.pure || 0).toFixed(3);
//       const close = parseFloat(retailer.opening || 0).toFixed(3); // Initially set to opening

//       setUpdateData({
//         retailer_id: retailer.retailer_id || "",
//         retailer_date: retailer.retailer_date || "",
//         supplier_id: retailer.supplier_id || "",
//         return_type: retailer.return_type || "Pure",
//         pure, // From API (e.g., "200.000")
//         opening, // From API (e.g., "1000.000")
//         current, // From API (e.g., "1450.000")
//         close, // Initially set to opening (e.g., "1000.000")
//         initial_close: initialClose, // From API (e.g., "250.000")
//         total_pure: parseFloat(retailer.total_pure || 0).toFixed(3), // From API (e.g., "450.000")
//         total_amount: totalAmount || "0",
//         items: formattedItems,
//         supplier_details: {
//           supplier_id: retailer.supplier_id || "",
//           name: retailer.supplier_details?.name || null,
//           mobile: retailer.supplier_details?.mobile || null,
//           address: retailer.supplier_details?.address || null,
//         },
//       });

//       if (retailer.supplier_id) {
//         fetchSupplierDetails(retailer.supplier_id);
//       }
//     } catch (error) {
//       console.error("Error fetching retailer data:", error);
//       toast.error(
//         "Failed to load retailer data: " + error.message,
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch supplier details
//   const fetchSupplierDetails = async (supplierId) => {
//     try {
//       const supplier = supplierGetting.find(
//         (s) => s.supplier_id === supplierId
//       );

//       if (supplier) {
//         setSelectedSupplier(supplier);
//         setSearchTerm(`${supplier.supplier_id} - ${supplier.name}`);
//         setUpdateData((prev) => ({
//           ...prev,
//           supplier_details: {
//             supplier_id: supplier.supplier_id,
//             name: supplier.name,
//             mobile: supplier.mobile,
//             address: supplier.address,
//           },
//         }));
//       } else {
//         const response = await axios.get(`${ApiUrl}/Api/supplier.php`);
//         const suppliers = response.data?.data || [];
//         setSupplierGetting(suppliers);

//         const matchedSupplier = suppliers.find(
//           (s) => s.supplier_id === supplierId
//         );
//         if (matchedSupplier) {
//           setSelectedSupplier(matchedSupplier);
//           setSearchTerm(
//             `${matchedSupplier.supplier_id} - ${matchedSupplier.name}`
//           );
//           setUpdateData((prev) => ({
//             ...prev,
//             supplier_details: {
//               supplier_id: matchedSupplier.supplier_id,
//               name: matchedSupplier.name,
//               mobile: matchedSupplier.mobile,
//               address: matchedSupplier.address,
//             },
//           }));
//         } else {
//           setSelectedSupplier(null);
//           setSearchTerm(supplierId);
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching supplier details:", error);
//       setSelectedSupplier(null);
//       setSearchTerm(supplierId);
//       toast.error("Failed to load supplier details", 3000, "topRight");
//     }
//   };

//   // Update totals when items change
//   useEffect(() => {
//     const totalPure = updateData.items
//       .reduce((sum, item) => sum + parseFloat(item.pure || 0), 0)
//       .toFixed(3);
//     const totalAmount = updateData.items
//       .reduce((sum, item) => sum + parseFloat(item.total_amount || 0), 0)
//       .toFixed(3);

//     setUpdateData((prev) => ({
//       ...prev,
//       total_pure: totalPure,
//       total_amount: totalAmount,
//     }));
//   }, [updateData.items]);

//   // Update current balance
//   useEffect(() => {
//     const opening = parseFloat(updateData.opening) || 0;
//     const totalPure = parseFloat(updateData.total_pure) || 0;
//     const current = (opening + totalPure).toFixed(3);
//     setUpdateData((prev) => ({ ...prev, current }));
//   }, [updateData.opening, updateData.total_pure]);

//   // Update closing balance when pure changes
//   useEffect(() => {
//     const initialClose = parseFloat(updateData.initial_close) || 0;
//     const pure = parseFloat(updateData.pure) || 0;
//     const close = (initialClose - pure).toFixed(3);
//     setUpdateData((prev) => ({ ...prev, close }));
//   }, [updateData.pure, updateData.initial_close]);

//   // Calculate pure and total_amount for new item
//   useEffect(() => {
//     let pure = "";
//     let total_amount = "";

//     if (newItem.weight && newItem.purity && newItem.quantity) {
//       const weight = parseFloat(newItem.weight);
//       const purity = parseFloat(newItem.purity);
//       const quantity = parseFloat(newItem.quantity);

//       if (!isNaN(weight) && !isNaN(purity) && !isNaN(quantity)) {
//         const singlePure = (weight * purity) / 100;
//         pure = (quantity * singlePure).toFixed(3);
//         total_amount = (quantity * weight * (purity / 100)).toFixed(3);
//       }
//     }

//     setNewItem((prev) => ({ ...prev, pure, total_amount }));
//   }, [newItem.weight, newItem.purity, newItem.quantity]);

//   // Reset type if item is "Bar"
//   useEffect(() => {
//     if (newItem.item === "Bar") {
//       setNewItem((prev) => ({ ...newItem, type: "" }));
//     }
//   }, [newItem.item]);

//   // Handle supplier input change
//   const handleSupplierInputChange = (value) => {
//     setSearchTerm(value);
//     setShowDropdown(true);
//     if (!value) {
//       setSelectedSupplier(null);
//       setUpdateData((prev) => ({
//         ...prev,
//         supplier_id: "",
//         supplier_details: {
//           supplier_id: "",
//           name: null,
//           mobile: null,
//           address: null,
//         },
//       }));
//     }
//   };

//   // Fetch data on component mount
//   useEffect(() => {
//     if (toggleSidebar) toggleSidebar();
//     if (id) {
//       fetchRetailerData();
//       fetchProductType();
//       fetchSupplierType();
//     }
//   }, [id]);

//   // Add new item
//   const handleAddItem = () => {
//     if (!newItem.item) {
//       toast.error("Please select an item", 3000, "topRight");
//       return;
//     }
//     if (!newItem.category) {
//       toast.error("Please select a category", 3000, "topRight");
//       return;
//     }
//     if (newItem.item !== "Bar" && !newItem.type) {
//       toast.error("Please select a type", 3000, "topRight");
//       return;
//     }
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
//       toast.error("Please enter a valid quantity", 3000, "topRight");
//       return;
//     }
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
//       toast.error("Please enter a valid weight", 3000, "topRight");
//       return;
//     }
//     if (!newItem.purity || parseFloat(newItem.purity) <= 0) {
//       toast.error("Please enter a valid purity", 3000, "topRight");
//       return;
//     }
//     if (newItem.item === "Others" && !newItem.other_name) {
//       toast.error("Please enter a name for 'Others'", 3000, "topRight");
//       return;
//     }

//     const newItems = [
//       ...updateData.items,
//       {
//         id: (updateData.items.length + 1).toString(),
//         retailer_id: updateData.retailer_id,
//         item: newItem.item,
//         other_name: newItem.other_name,
//         category: newItem.category,
//         type: newItem.type,
//         quantity: newItem.quantity,
//         weight: newItem.weight,
//         purity: newItem.purity,
//         pure: newItem.pure,
//         total_amount: newItem.total_amount,
//       },
//     ];

//     setUpdateData((prev) => ({
//       ...prev,
//       items: newItems,
//     }));

//     setNewItem({
//       item: "",
//       category: "",
//       other_name: "",
//       type: "",
//       quantity: "",
//       weight: "",
//       purity: "",
//       pure: "",
//       total_amount: "",
//     });
//   };

//   // Remove item
//   const handleRemoveItem = (itemId) => {
//     const updatedItems = updateData.items.filter((item) => item.id !== itemId);
//     const reindexedItems = updatedItems.map((item, index) => ({
//       ...item,
//       id: (index + 1).toString(),
//     }));

//     setUpdateData((prev) => ({
//       ...prev,
//       items: reindexedItems,
//     }));
//   };

//   // Edit item
//   const handleEditItem = (itemId) => {
//     const itemToEdit = updateData.items.find((item) => item.id === itemId);
//     if (itemToEdit) {
//       setNewItem({
//         item: itemToEdit.item,
//         category: itemToEdit.category,
//         other_name: itemToEdit.other_name,
//         type: itemToEdit.type,
//         quantity: itemToEdit.quantity,
//         weight: itemToEdit.weight,
//         purity: itemToEdit.purity,
//         pure: itemToEdit.pure,
//         total_amount: itemToEdit.total_amount,
//       });
//       setEditingItemId(itemId);
//     }
//   };

//   // Update item
//   const handleUpdateItem = () => {
//     if (editingItemId === null) return;

//     const updatedItems = updateData.items.map((item) => {
//       if (item.id === editingItemId) {
//         return {
//           ...item,
//           item: newItem.item,
//           retailer_id: updateData.retailer_id,
//           category: newItem.category,
//           other_name: newItem.other_name,
//           type: newItem.type,
//           quantity: newItem.quantity,
//           weight: newItem.weight,
//           purity: newItem.purity,
//           pure: newItem.pure,
//           total_amount: newItem.total_amount,
//         };
//       }
//       return item;
//     });

//     setUpdateData((prev) => ({
//       ...prev,
//       items: updatedItems,
//     }));

//     setNewItem({
//       item: "",
//       category: "",
//       other_name: "",
//       type: "",
//       quantity: "",
//       weight: "",
//       purity: "",
//       pure: "",
//       total_amount: "",
//     });
//     setEditingItemId(null);
//   };

//   // Validate form
//   const validateForm = () => {
//     if (!updateData.retailer_id) {
//       toast.error("Retailer ID is required", 3000, "topRight");
//       return false;
//     }
//     if (!updateData.retailer_date) {
//       toast.error("Retailer date is required", 3000, "topRight");
//       return false;
//     }
//     if (!updateData.supplier_id) {
//       toast.error("Please select a supplier", 3000, "topRight");
//       return false;
//     }
//     if (updateData.items.length === 0) {
//       toast.error("Please add at least one item", 3000, "topRight");
//       return false;
//     }
//     if (!updateData.pure || parseFloat(updateData.pure) <= 0) {
//       toast.error("Please enter a valid pure value", 3000, "topRight");
//       return false;
//     }
//     return true;
//   };

//   // Prepare payload for API
//   const preparePayload = () => ({
//     id: id,
//     retailer_id: updateData.retailer_id,
//     retailer_date: updateData.retailer_date,
//     supplier_id: updateData.supplier_id,
//     return_type: updateData.return_type,
//     pure: updateData.pure || "0",
//     opening: updateData.opening || "0",
//     current: updateData.current || "0",
//     close: updateData.close || "0",
//     total_pure: updateData.total_pure || "0",
//     total_amount: updateData.total_amount || "0",
//     items: updateData.items.map((item) => ({
//       id: item.id,
//       category: item.category,
//       quantity: item.quantity,
//       item: item.item,
//       weight: item.weight,
//       type: item.type,
//       other_name: item.other_name,
//       percentage: item.purity,
//       pure: item.pure,
//       retailer_id: updateData.retailer_id,
//       total_amount: item.total_amount,
//     })),
//   });

//   // Save retailer data
//   const handleSave = async () => {
//     if (!validateForm()) return;

//     setLoading(true);
//     try {
//       const payload = preparePayload();
//       const response = await axios.put(
//         `${ApiUrl}/Api/retailer_details.php/${id}`,
//         payload
//       );

//       if (response.status === 200) {
//         toast.success("Retailer updated successfully!", 3000, "topRight");
//         navigate("/retailers");
//       } else {
//         toast.error(
//           response.data.message || "Failed to update retailer data",
//           3000,
//           "topRight"
//         );
//       }
//     } catch (error) {
//       console.error("Error updating data:", error);
//       toast.error(
//         `Failed to update retailer: ${
//           error.response?.data?.message || error.message
//         }`,
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Print retailer data
//   const handlePrint = async () => {
//     if (!validateForm()) return;

//     setLoading(true);
//     try {
//       const payload = preparePayload();
//       const response = await axios.put(
//         `${ApiUrl}/Api/retailer_details.php/${id}`,
//         payload
//       );

//       if (response.status === 200) {
//         toast.success("Retailer updated successfully!", 3000, "topRight");
//         navigate(`/retailer-bill/${updateData.retailer_id}`);
//       } else {
//         toast.error(
//           response.data.message || "Failed to update retailer data",
//           3000,
//           "topRight"
//         );
//       }
//     } catch (error) {
//       console.error("Error updating data for print:", error);
//       toast.error(
//         `Failed to update retailer: ${
//           error.response?.data?.message || error.message
//         }`,
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//       setShowModal(false);
//     }
//   };

//   // Select supplier
//   const handleSelectSupplier = (supplier) => {
//     setSelectedSupplier({
//       supplier_id: supplier.supplier_id,
//       name: supplier.name || "",
//       mobile: supplier.mobile || "",
//       address: supplier.address || "",
//     });
//     setSearchTerm(`${supplier.supplier_id} - ${supplier.name}`);
//     setUpdateData((prev) => ({
//       ...prev,
//       supplier_id: supplier.supplier_id,
//       supplier_details: {
//         supplier_id: supplier.supplier_id,
//         name: supplier.name,
//         mobile: supplier.mobile,
//         address: supplier.address,
//       },
//     }));
//     setShowDropdown(false);
//   };

//   // Filter suppliers for dropdown
//   const filteredSuppliers = supplierGetting.filter(
//     (supplier) =>
//       supplier.supplier_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       supplier.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Clear form
//   const handleClear = () => {
//     setUpdateData({
//       retailer_id: "",
//       retailer_date: "",
//       supplier_id: "",
//       return_type: "Pure",
//       pure: "",
//       opening: "0",
//       current: "0",
//       close: "0",
//       initial_close: "0",
//       total_pure: "0",
//       total_amount: "0",
//       items: [],
//       supplier_details: {
//         supplier_id: "",
//         name: null,
//         mobile: null,
//         address: null,
//       },
//     });
//     setNewItem({
//       item: "",
//       category: "",
//       other_name: "",
//       type: "",
//       quantity: "",
//       weight: "",
//       purity: "",
//       pure: "",
//       total_amount: "",
//     });
//     setSelectedSupplier(null);
//     setSearchTerm("");
//     setEditingItemId(null);
//   };

//   return (
//     <div className="container-fluid py-2">
//       <div className="row">
//         <div className="col-lg-3">
//           <div className="card p-2">
//             <div className="row">
//               <div className="col-md-6">
//                 <label className="form-label">Retailer ID</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={updateData.retailer_id}
//                   disabled
//                   readOnly
//                 />
//               </div>
//               <div className="col-md-6">
//                 <label className="form-label">Date</label>
//                 <input
//                   type="date"
//                   className="form-control"
//                   value={updateData.retailer_date}
//                   onChange={(e) =>
//                     setUpdateData({
//                       ...updateData,
//                       retailer_date: e.target.value,
//                     })
//                   }
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-9">
//           <div className="card p-2">
//             <div className="row g-3">
//               <div className="col-md-3">
//                 <label className="form-label">Supplier</label>
//                 <div className="input-group">
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Search supplier..."
//                     value={searchTerm}
//                     onChange={(e) => handleSupplierInputChange(e.target.value)}
//                     onFocus={() => setShowDropdown(true)}
//                   />
//                   {searchTerm && (
//                     <button
//                       className="btn btn-outline-secondary h-75"
//                       type="button"
//                       onClick={() => {
//                         setSelectedSupplier(null);
//                         setSearchTerm("");
//                         setUpdateData((prev) => ({
//                           ...prev,
//                           supplier_id: "",
//                           supplier_details: {
//                             supplier_id: "",
//                             name: null,
//                             mobile: null,
//                             address: null,
//                           },
//                         }));
//                       }}
//                     >
//                       <i className="bi bi-x"></i>
//                     </button>
//                   )}
//                 </div>
//                 {showDropdown && filteredSuppliers.length > 0 && (
//                   <div
//                     className="dropdown-menu show w-100"
//                     style={{ position: "absolute", zIndex: 1000 }}
//                   >
//                     {filteredSuppliers.map((supplier) => (
//                       <button
//                         key={supplier.supplier_id}
//                         className="dropdown-item"
//                         onClick={() => handleSelectSupplier(supplier)}
//                         type="button"
//                       >
//                         {supplier.supplier_id} - {supplier.name}
//                       </button>
//                     ))}
//                   </div>
//                 )}
//               </div>
//               <div className="col-md-3">
//                 <label className="form-label">Supplier Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                   value={
//                     updateData.supplier_details?.name ||
//                     selectedSupplier?.name ||
//                     ""
//                   }
//                   readOnly
//                   disabled
//                 />
//               </div>
//               <div className="col-md-3">
//                 <label className="form-label">Mobile</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                   value={
//                     updateData.supplier_details?.mobile ||
//                     selectedSupplier?.mobile ||
//                     ""
//                   }
//                   readOnly
//                   disabled
//                 />
//               </div>
//               <div className="col-md-3">
//                 <label className="form-label">Address</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                   value={
//                     updateData.supplier_details?.address ||
//                     selectedSupplier?.address ||
//                     ""
//                   }
//                   readOnly
//                   disabled
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="card p-2 mt-1">
//         <div className="row g-3">
//           <div className="col-md-2">
//             <label className="form-label">Item</label>
//             <select
//               className="form-select"
//               value={newItem.item}
//               onChange={(e) => setNewItem({ ...newItem, item: e.target.value })}
//             >
//               <option value="">Select Item</option>
//               <option value="Bar">Bar</option>
//               <option value="Jewels">Jewels</option>
//               <option value="Others">Others</option>
//             </select>
//           </div>
//           {newItem.item === "Others" && (
//             <div className="col-md-2">
//               <label className="form-label">Others Name</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 placeholder="Others Name"
//                 value={newItem.other_name}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, other_name: e.target.value })
//                 }
//               />
//             </div>
//           )}
//           <div className="col-md-2">
//             <label className="form-label">Category</label>
//             <select
//               className="form-select"
//               value={newItem.category}
//               onChange={(e) =>
//                 setNewItem({ ...newItem, category: e.target.value })
//               }
//             >
//               <option value="">Select Category</option>
//               <option value="Gold">Gold</option>
//               <option value="Silver">Silver</option>
//             </select>
//           </div>
//           <div className="col-md-2">
//             <label className="form-label">Type</label>
//             <select
//               className="form-select"
//               value={newItem.type}
//               onChange={(e) => setNewItem({ ...newItem, type: e.target.value })}
//               disabled={newItem.item === "Bar"}
//             >
//               <option value="">Select Type</option>
//               {Array.isArray(typeGetting) &&
//                 typeGetting.map((item) => (
//                   <option key={item._id} value={item.type}>
//                     {item.type}
//                   </option>
//                 ))}
//             </select>
//           </div>
//           <div className="col-md-1">
//             <label className="form-label">Qty</label>
//             <input
//               type="text"
//               inputMode="numeric"
//               pattern="[0-9]*"
//               maxLength="5"
//               className="form-control"
//               placeholder="Quantity"
//               value={newItem.quantity}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 if (/^\d*$/.test(value)) {
//                   setNewItem({ ...newItem, quantity: value });
//                 }
//               }}
//             />
//           </div>
//           <div className="col-md-1">
//             <label className="form-label">Weight (g)</label>
//             <input
//               type="text"
//               inputMode="decimal"
//               className="form-control"
//               placeholder="Weight"
//               value={newItem.weight}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 if (/^\d*\.?\d*$/.test(value)) {
//                   setNewItem({ ...newItem, weight: value });
//                 }
//               }}
//             />
//           </div>
//           <div className="col-md-1">
//             <label className="form-label">Purity (%)</label>
//             <input
//               type="text"
//               inputMode="decimal"
//               className="form-control"
//               placeholder="Purity"
//               value={newItem.purity}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 if (/^\d{0,3}(\.\d{0,2})?$/.test(value)) {
//                   const num = parseFloat(value);
//                   if (value === "" || (!isNaN(num) && num <= 100)) {
//                     setNewItem({ ...newItem, purity: value });
//                   }
//                 }
//               }}
//             />
//           </div>
//           <div className="col-md-1">
//             <label className="form-label">Pure (g)</label>
//             <input
//               type="text"
//               className="form-control"
//               value={newItem.pure || ""}
//               readOnly
//             />
//           </div>
//           <div className="col-md-1">
//             {editingItemId === null ? (
//               <button
//                 className="btn btn-success btn-sm mx-2 mt-4"
//                 onClick={handleAddItem}
//               >
//                 <i className="bi bi-plus"></i>
//               </button>
//             ) : (
//               <button
//                 className="btn btn-info btn-sm mx-2 mt-4"
//                 onClick={handleUpdateItem}
//               >
//                 <i className="bi bi-check"></i>
//               </button>
//             )}
//           </div>
//         </div>
//       </div>

//       <div className="container-fluid p-2">
//         <div className="row">
//           <div className="col-lg-9">
//             <div className="card card-body p-2">
//               <h6>Item List</h6>
//               <div className="p-2" style={{ backgroundColor: "#E8F0FA" }}>
//                 <div className="table-container">
//                   <table className="table table-layout-fixed w-100">
//                     <thead className="bg-light">
//                       <tr>
//                         <th>S.No</th>
//                         <th>Item</th>
//                         <th>Category</th>
//                         <th>Type</th>
//                         <th>Quantity</th>
//                         <th>Weight(g)</th>
//                         <th>Purity (%)</th>
//                         <th>Pure(g)</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {updateData.items.length > 0 ? (
//                         updateData.items.map((item, index) => (
//                           <tr key={index}>
//                             <td>{index + 1}</td>
//                             <td>
//                               {item.item}
//                               {item.other_name ? ` (${item.other_name})` : ""}
//                             </td>
//                             <td>{item.category}</td>
//                             <td>{item.type || "-"}</td>
//                             <td>{item.quantity}</td>
//                             <td>{item.weight}g</td>
//                             <td>{item.purity}%</td>
//                             <td>{item.pure}g</td>
//                             <td>
//                               <button
//                                 className="btn btn-sm btn-light me-1"
//                                 onClick={() => handleEditItem(item.id)}
//                               >
//                                 <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
//                               </button>
//                               <button
//                                 className="btn btn-sm btn-light me-1"
//                                 onClick={() => handleRemoveItem(item.id)}
//                               >
//                                 <i className="fa-solid fa-trash text-danger fs-6"></i>
//                               </button>
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td colSpan="9" className="text-center">
//                             No items added yet
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-3">
//             <div className="card p-3">
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Total Pure (g)</label>
//                 </div>
//                 <div className="col-md-6">
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={updateData.total_pure || "0"}
//                     readOnly
//                   />
//                 </div>
//               </div>
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Return Type</label>
//                 </div>
//                 <div className="col-md-6">
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={updateData.return_type || "Pure"}
//                     readOnly
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                   />
//                 </div>
//               </div>
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Pure (g)</label>
//                 </div>
//                 <div className="col-md-6">
//                   <input
//                     type="text"
//                     inputMode="decimal"
//                     className="form-control"
//                     value={updateData.pure || ""}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (/^\d*\.?\d*$/.test(value)) {
//                         setUpdateData({ ...updateData, pure: value });
//                       }
//                     }}
//                   />
//                 </div>
//               </div>
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Opening</label>
//                 </div>
//                 <div className="col-md-6">
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={updateData.opening || "0"}
//                     readOnly
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                   />
//                 </div>
//               </div>
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Current</label>
//                 </div>
//                 <div className="col-md-6">
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={updateData.current || "0"}
//                     readOnly
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                   />
//                 </div>
//               </div>
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Closing</label>
//                 </div>
//                 <div className="col-md-6">
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={updateData.close || "0"}
//                     readOnly
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                   />
//                 </div>
//               </div>
//               <div className="d-flex justify-content-between mt-2">
//                 <button
//                   className="btn btn-secondary btn-sm"
//                   onClick={() => navigate("/retailers")}
//                 >
//                   <i className="fa-solid fa-arrow-left"></i> Back
//                 </button>
//                 <button className="btn btn-danger btn-sm" onClick={handleClear}>
//                   <i className="bi bi-x-circle"></i> Clear
//                 </button>
//                 <button
//                   className="btn btn-primary btn-sm"
//                   onClick={() => setShowModal(true)}
//                   disabled={loading}
//                 >
//                   <i className="bi bi-printer"></i> Print
//                 </button>
//                 <button
//                   className="btn btn-success btn-sm"
//                   onClick={handleSave}
//                   disabled={loading}
//                 >
//                   <i className="bi bi-save"></i> Save
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{ display: showModal ? "block" : "none" }}
//         tabIndex="-1"
//         aria-labelledby="printModalLabel"
//         aria-hidden={!showModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6 className="modal-title text-primary" id="printModalLabel">
//                 Print Confirmation
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={() => setShowModal(false)}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <div className="text-center">
//                 <p>Do you want to print the retailer?</p>
//               </div>
//               <div className="d-flex justify-content-center mt-4">
//                 <button
//                   type="button"
//                   className="btn btn-secondary btn-sm mx-2"
//                   onClick={() => setShowModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary btn-sm"
//                   onClick={handlePrint}
//                   disabled={loading}
//                 >
//                   {loading ? "Processing..." : "Print"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {showModal && <div className="modal-backdrop fade show"></div>}
//     </div>
//   );
// }
// export default UpdateRetailer;
// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import ApiUrl from "../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext";

// function UpdateRetailer({ toggleSidebar }) {
//   const { id } = useParams();
//   const toast = useToast();
//   const navigate = useNavigate();
//   const [showModal, setShowModal] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [productTypes, setProductTypes] = useState([]);
//   const [suppliers, setSuppliers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedSupplier, setSelectedSupplier] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [editingItemId, setEditingItemId] = useState(null);
//   const [generateNumber, setGenerateNumber] = useState("");
//   const [userdata, setUserdata] = useState([]);
//   const [loggedInUser, setLoggedInUser] = useState(null);
//   const [selectedManager, setSelectedManager] = useState("");
//   const [selectedStaff, setSelectedStaff] = useState("");
//   const [staffList, setStaffList] = useState([]);
//   const [isManagerLocked, setIsManagerLocked] = useState(false);
//   const [isStaffLocked, setIsStaffLocked] = useState(false);
//   const [adjustmentInput, setAdjustmentInput] = useState(""); // ← NEW: same as AddPurchase

//   const [formData, setFormData] = useState({
//     retailer_id: "",
//     retailer_date: "",
//     supplier_id: "",
//     return_type: "",
//     enter_amount: "",
//     amount: "",
//     pure: "",
//     opening: "0",
//     current: "0.000",
//     close: "0.000",
//     total_pure: "0.000",
//     total_amount: "0.000",
//     items: [],
//     supplier_details: {
//       supplier_id: "",
//       name: null,
//       mobile: null,
//       address: null,
//     },
//   });

//   const [newItem, setNewItem] = useState({
//     item: "",
//     category: "",
//     other_name: "",
//     type: "",
//     quantity: 1,
//     weight: "",
//     purity: "",
//     pure: "0.000",
//     total_amount: "0.000",
//     adjustment: "0.000",
//   });

//   useEffect(() => {
//     if (toggleSidebar) toggleSidebar();
//     fetchUserData();
//     fetchLoggedInUser();
//     fetchInitialData();
//   }, [id]);

//   const fetchInitialData = async () => {
//     try {
//       setLoading(true);
//       const typeResponse = await axios.get(`${ApiUrl}/Api/product_type.php`);
//       setProductTypes(typeResponse.data?.data || []);

//       const supplierResponse = await axios.get(`${ApiUrl}/Api/supplier.php`);
//       setSuppliers(supplierResponse.data?.data || []);

//       const retailerResponse = await axios.get(
//         `${ApiUrl}/Api/retailer_details.php/${id}`
//       );
//       if (!retailerResponse.data || !Array.isArray(retailerResponse.data.data)) {
//         throw new Error("Invalid response format");
//       }

//       const retailer = retailerResponse.data.data.find((r) => r.id === id);
//       if (!retailer) {
//         throw new Error(`Retailer with ID ${id} not found`);
//       }

//       const formattedItems = Array.isArray(retailer.items)
//         ? retailer.items.map((item, index) => {
//           const weight = parseFloat(item.weight || 0);
//           const purity = parseFloat(item.percentage || item.purity || 0);
//           const quantity = parseFloat(item.quantity || 0);
//           const singlePure =
//             !isNaN(weight) && !isNaN(purity)
//               ? (weight * purity) / 100
//               : 0;
//           const pure = (quantity * singlePure).toFixed(3);
//           const total_amount = pure;
//           return {
//             id: item.id || (index + 1).toString(),
//             retailer_id: retailer.retailer_id || "",
//             item: item.item_name || item.item || "",
//             category: item.category || "",
//             other_name: item.other_name || "",
//             type: item.type || "",
//             quantity: item.quantity || "",
//             weight: item.weight || "",
//             purity: item.percentage || item.purity || "",
//             pure,
//             total_amount,
//             adjustment: parseFloat(item.adjustment || 0).toFixed(3), // ← Load saved adjustment
//           };
//         })
//         : [];

//       setGenerateNumber(retailer.retailer_id || "");
//       const openingValue = parseFloat(retailer.opening || "0");
//       setFormData({
//         retailer_id: retailer.retailer_id || "",
//         retailer_date: retailer.retailer_date || new Date().toISOString().split("T")[0],
//         supplier_id: retailer.supplier_id || "",
//         return_type: retailer.return_type || "Amount",
//         enter_amount: parseFloat(retailer.enter_amount || "55000").toFixed(3),
//         amount: parseFloat(retailer.amount || "25000").toFixed(3),
//         pure: retailer.pure ? parseFloat(retailer.pure).toFixed(3) : "",
//         opening: openingValue === 0 ? "0" : openingValue.toFixed(3),
//         current: parseFloat(retailer.current || "55000").toFixed(3),
//         close: parseFloat(retailer.close || "30000").toFixed(3),
//         total_pure: parseFloat(retailer.total_pure || 0).toFixed(3),
//         total_amount: parseFloat(retailer.total_amount || 0).toFixed(3),
//         items: formattedItems,
//         supplier_details: {
//           supplier_id: retailer.supplier_id || "",
//           name: retailer.supplier_details?.name || null,
//           mobile: retailer.supplier_details?.mobile || null,
//           address: retailer.supplier_details?.address || null,
//         },
//       });

//       if (retailer.supplier_id) {
//         setSearchTerm(
//           `${retailer.supplier_id} - ${retailer.supplier_details?.name || ""}`
//         );
//         setSelectedSupplier({
//           supplier_id: retailer.supplier_id,
//           name: retailer.supplier_details?.name || "",
//           mobile: retailer.supplier_details?.mobile || "",
//           address: retailer.supplier_details?.address || "",
//         });
//       }
//     } catch (error) {
//       console.error("Initialization error:", error);
//       toast.error("Failed to initialize form data", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Pure calculation with adjustment
//   useEffect(() => {
//     let pure = "0.000";
//     let total_amount = "0.000";

//     if (newItem.weight && newItem.purity && newItem.quantity) {
//       const weight = parseFloat(newItem.weight) || 0;
//       const purity = parseFloat(newItem.purity) || 0;
//       const quantity = parseFloat(newItem.quantity) || 1;

//       if (purity > 100) {
//         toast.error("Purity cannot exceed 100%", 3000, "topRight");
//         setNewItem((prev) => ({ ...prev, purity: "" }));
//         return;
//       }

//       const singlePure = (weight * purity) / 100;
//       let calculatedPure = quantity * singlePure;

//       // Apply adjustment
//       const adjustment = parseFloat(newItem.adjustment) || 0;
//       calculatedPure += adjustment;

//       pure = calculatedPure.toFixed(3);
//       total_amount = (quantity * singlePure).toFixed(3);
//     }

//     setNewItem((prev) => ({ ...prev, pure, total_amount }));
//   }, [newItem.weight, newItem.purity, newItem.quantity, newItem.adjustment, toast]);

//   useEffect(() => {
//     const totalPure = formData.items
//       .reduce((sum, item) => sum + parseFloat(item.pure || 0), 0)
//       .toFixed(3);
//     const totalAmount = formData.items
//       .reduce((sum, item) => sum + parseFloat(item.total_amount || 0), 0)
//       .toFixed(3);
//     setFormData((prev) => ({ ...prev, total_pure: totalPure, total_amount: totalAmount }));
//   }, [formData.items]);

//   useEffect(() => {
//     const opening = parseFloat(formData.opening) || 0;
//     let current = "0.000";

//     if (formData.return_type === "Amount") {
//       const enter_amount = parseFloat(formData.enter_amount) || 0;
//       current = (opening + enter_amount).toFixed(3);
//     } else if (formData.return_type === "Pure") {
//       const totalPure = parseFloat(formData.total_pure) || 0;
//       current = (opening + totalPure).toFixed(3);
//     }

//     setFormData((prev) => ({ ...prev, current }));
//   }, [formData.total_pure, formData.opening, formData.enter_amount, formData.return_type]);

//   useEffect(() => {
//     const current = parseFloat(formData.current) || 0;
//     let close = "0.000";

//     if (formData.return_type === "Pure") {
//       const pure = parseFloat(formData.pure) || 0;
//       if (pure > current) {
//         toast.error("Pure value cannot exceed Current", 3000, "topRight");
//         setFormData((prev) => ({ ...prev, pure: "" }));
//         close = current.toFixed(3);
//       } else {
//         close = (current - pure).toFixed(3);
//       }
//     } else if (formData.return_type === "Amount") {
//       const amount = parseFloat(formData.amount) || 0;
//       if (amount > current) {
//         toast.error("Paid value cannot exceed Current", 3000, "topRight");
//         setFormData((prev) => ({ ...prev, amount: "" }));
//         close = current.toFixed(3);
//       } else {
//         close = (current - amount).toFixed(3);
//       }
//     }

//     setFormData((prev) => ({ ...prev, close }));
//   }, [formData.current, formData.pure, formData.amount, formData.return_type, toast]);

//   useEffect(() => {
//     if (newItem.item === "Bar") {
//       setNewItem((prev) => ({ ...prev, type: "" }));
//     }
//   }, [newItem.item]);

//   const handleSelectSupplier = async (supplier) => {
//     setSelectedSupplier(supplier);
//     setSearchTerm(`${supplier.supplier_id} - ${supplier.name}`);
//     setFormData((prev) => ({
//       ...prev,
//       supplier_id: supplier.supplier_id,
//       supplier_details: {
//         supplier_id: supplier.supplier_id,
//         name: supplier.name,
//         mobile: supplier.mobile,
//         address: supplier.address,
//       },
//     }));
//     setShowDropdown(false);
//     await fetchOpeningBalance(supplier.supplier_id);
//   };

//   const fetchOpeningBalance = async (supplierId) => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/retailer_details.php`);
//       let supplierRetailers = response.data.data.filter(
//         (retailer) =>
//           retailer.supplier_id === supplierId &&
//           retailer.return_type === formData.return_type
//       );

//       let previousRetailers = supplierRetailers.filter((retailer) => {
//         if (retailer.retailer_date < formData.retailer_date) return true;
//         if (retailer.retailer_date > formData.retailer_date) return false;
//         return parseInt(retailer.id) < parseInt(id);
//       });

//       let formattedOpening = "0";
//       if (previousRetailers.length > 0) {
//         previousRetailers.sort((a, b) => {
//           if (a.retailer_date !== b.retailer_date) {
//             return b.retailer_date.localeCompare(a.retailer_date);
//           }
//           return parseInt(b.id) - parseInt(a.id);
//         });
//         const latestPrevious = previousRetailers[0];
//         const totalOpening = parseFloat(latestPrevious.close || 0);
//         formattedOpening = totalOpening === 0 ? "0" : totalOpening.toFixed(3);
//       }

//       setFormData((prev) => ({
//         ...prev,
//         opening: formattedOpening,
//       }));
//     } catch (error) {
//       console.error("Error fetching supplier retailers:", error);
//       setFormData((prev) => ({
//         ...prev,
//         opening: "0",
//       }));
//     }
//   };

//   useEffect(() => {
//     if (selectedSupplier && formData.return_type) {
//       fetchOpeningBalance(selectedSupplier.supplier_id);
//     } else {
//       setFormData((prev) => ({
//         ...prev,
//         opening: "0",
//       }));
//     }
//   }, [formData.return_type, selectedSupplier, toast]);

//   const clearSupplier = () => {
//     setSelectedSupplier(null);
//     setSearchTerm("");
//     setFormData((prev) => ({
//       ...prev,
//       supplier_id: "",
//       supplier_details: {
//         supplier_id: "",
//         name: null,
//         mobile: null,
//         address: null,
//       },
//       opening: "0",
//     }));
//   };

//   const handleAddItem = () => {
//     if (!validateItem()) return;

//     const newItems = [
//       ...formData.items,
//       {
//         id: (formData.items.length + 1).toString(),
//         retailer_id: formData.retailer_id,
//         item: newItem.item,
//         other_name: newItem.other_name,
//         category: newItem.category,
//         type: newItem.type,
//         quantity: parseFloat(newItem.quantity) || 0,
//         weight: parseFloat(newItem.weight) || 0,
//         purity: parseFloat(newItem.purity) || 0,
//         pure: parseFloat(newItem.pure) || 0,
//         total_amount: parseFloat(newItem.total_amount) || 0,
//         adjustment: parseFloat(newItem.adjustment) || 0,
//       },
//     ];

//     setFormData((prev) => ({ ...prev, items: newItems }));
//     resetNewItem();
//   };

//   const validateItem = () => {
//     if (!newItem.item) {
//       toast.error("Please select an item", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.category) {
//       toast.error("Please select a category", 3000, "topRight");
//       return false;
//     }
//     if (newItem.item !== "Bar" && !newItem.type) {
//       toast.error("Please select a type", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
//       toast.error("Please enter a valid quantity", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
//       toast.error("Please enter a valid weight", 3000, "topRight");
//       return false;
//     }
//     if (
//       !newItem.purity ||
//       parseFloat(newItem.purity) <= 0 ||
//       parseFloat(newItem.purity) > 100
//     ) {
//       toast.error("Please enter a valid purity (0-100%)", 3000, "topRight");
//       return false;
//     }
//     if (newItem.item === "Others" && !newItem.other_name) {
//       toast.error("Please enter a name for 'Others'", 3000, "topRight");
//       return false;
//     }
//     return true;
//   };

//   const resetNewItem = () => {
//     setNewItem({
//       item: "",
//       category: "",
//       other_name: "",
//       type: "",
//       quantity: 1,
//       weight: "",
//       purity: "",
//       pure: "0.000",
//       total_amount: "0.000",
//       adjustment: "0.000",
//     });
//     setAdjustmentInput("");
//     setEditingItemId(null);
//   };

//   const handleRemoveItem = (itemId) => {
//     const updatedItems = formData.items
//       .filter((item) => item.id !== itemId)
//       .map((item, index) => ({ ...item, id: (index + 1).toString() }));
//     setFormData((prev) => ({ ...prev, items: updatedItems }));
//   };

//   const handleEditItem = (itemId) => {
//     const itemToEdit = formData.items.find((item) => item.id === itemId);
//     if (itemToEdit) {
//       setNewItem({
//         item: itemToEdit.item,
//         category: itemToEdit.category,
//         other_name: itemToEdit.other_name || "",
//         type: itemToEdit.type || "",
//         quantity: itemToEdit.quantity.toString(),
//         weight: itemToEdit.weight.toString(),
//         purity: itemToEdit.purity.toString(),
//         pure: parseFloat(itemToEdit.pure || 0).toFixed(3),
//         total_amount: parseFloat(itemToEdit.total_amount || 0).toFixed(3),
//         adjustment: (itemToEdit.adjustment || 0).toFixed(3),
//       });
//       setAdjustmentInput("");
//       setEditingItemId(itemId);
//     }
//   };

//   const handleUpdateItem = () => {
//     if (!validateItem() || editingItemId === null) return;

//     const updatedItems = formData.items.map((item) =>
//       item.id === editingItemId
//         ? {
//           ...item,
//           item: newItem.item,
//           retailer_id: formData.retailer_id,
//           category: newItem.category,
//           other_name: newItem.other_name,
//           type: newItem.type,
//           quantity: parseFloat(newItem.quantity) || 0,
//           weight: parseFloat(newItem.weight) || 0,
//           purity: parseFloat(newItem.purity) || 0,
//           pure: parseFloat(newItem.pure) || 0,
//           total_amount: parseFloat(newItem.total_amount) || 0,
//           adjustment: parseFloat(newItem.adjustment) || 0,
//         }
//         : item
//     );

//     setFormData((prev) => ({ ...prev, items: updatedItems }));
//     resetNewItem();
//   };

//   const validateForm = () => {
//     if (!formData.retailer_id) {
//       toast.error("Retailer ID is required", 3000, "topRight");
//       return false;
//     }
//     if (!formData.retailer_date) {
//       toast.error("Retailer date is required", 3000, "topRight");
//       return false;
//     }
//     if (!formData.supplier_id) {
//       toast.error("Please select a supplier", 3000, "topRight");
//       return false;
//     }
//     if (formData.items.length === 0) {
//       toast.error("Please add at least one item", 3000, "topRight");
//       return false;
//     }
//     if (
//       formData.return_type === "Pure" &&
//       (!formData.pure || parseFloat(formData.pure) < 0)
//     ) {
//       toast.error("Please enter a valid pure value", 3000, "topRight");
//       return false;
//     }
//     if (
//       formData.return_type === "Amount" &&
//       (!formData.enter_amount || parseFloat(formData.enter_amount) <= 0)
//     ) {
//       toast.error("Please enter a valid amount", 3000, "topRight");
//       return false;
//     }
//     if (
//       formData.return_type === "Amount" &&
//       (!formData.amount || parseFloat(formData.amount) < 0)
//     ) {
//       toast.error("Please enter a valid paid amount", 3000, "topRight");
//       return false;
//     }
//     return true;
//   };

//   const preparePayload = () => {
//     let payload = {
//       id: id,
//       retailer_id: formData.retailer_id,
//       retailer_date: formData.retailer_date,
//       supplier_id: formData.supplier_id,
//       return_type: formData.return_type,
//       enter_amount: parseFloat(formData.enter_amount) || 0,
//       amount: parseFloat(formData.amount) || 0,
//       pure: parseFloat(formData.pure) || 0,
//       opening: parseFloat(formData.opening) || 0,
//       current: parseFloat(formData.current) || 0,
//       close: parseFloat(formData.close) || 0,
//       total_pure: parseFloat(formData.total_pure) || 0,
//       total_amount: parseFloat(formData.total_amount) || 0,
//       items: formData.items.map((item) => ({
//         id: item.id,
//         category: item.category,
//         quantity: parseFloat(item.quantity) || 0,
//         item: item.item,
//         weight: parseFloat(item.weight) || 0,
//         type: item.type,
//         other_name: item.other_name || "",
//         percentage: parseFloat(item.purity) || 0,
//         pure: parseFloat(item.pure) || 0,
//         total_amount: parseFloat(item.total_amount) || 0,
//         adjustment: parseFloat(item.adjustment) || 0,
//         retailer_id: formData.retailer_id,
//       })),
//     };

//     if (formData.return_type === "Pure") {
//       payload.enter_amount = 0;
//       payload.amount = 0;
//     } else if (formData.return_type === "Amount") {
//       payload.pure = 0;
//     } else {
//       payload.enter_amount = 0;
//       payload.amount = 0;
//       payload.pure = 0;
//     }

//     return payload;
//   };

//   const handleSave = async () => {
//     if (!validateForm()) return;

//     try {
//       setLoading(true);
//       const payload = preparePayload();
//       const response = await axios.put(
//         `${ApiUrl}/Api/retailer_details.php/${id}`,
//         payload
//       );

//       if (response.status === 200) {
//         toast.success("Retailer updated successfully!", 3000, "topRight");
//         navigate("/retailers");
//       } else {
//         toast.error(
//           response.data.message || "Failed to update retailer",
//           3000,
//           "topRight"
//         );
//       }
//     } catch (error) {
//       console.error("Submission error:", error);
//       toast.error(
//         error.response?.data?.message || "Failed to update retailer",
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePrint = async () => {
//     if (!validateForm()) return;

//     try {
//       setLoading(true);
//       const payload = preparePayload();
//       const response = await axios.put(
//         `${ApiUrl}/Api/retailer_details.php/${id}`,
//         payload
//       );

//       if (response.status === 200) {
//         toast.success("Retailer updated successfully!", 3000, "topRight");
//         navigate(`/retailer-bill/${formData.retailer_id}`);
//       } else {
//         toast.error(
//           response.data.message || "Failed to update retailer for print",
//           3000,
//           "topRight"
//         );
//       }
//     } catch (error) {
//       console.error("Print error:", error);
//       toast.error(
//         error.response?.data?.message || "Failed to update and print retailer",
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClear = () => {
//     setFormData({
//       retailer_id: generateNumber,
//       retailer_date: new Date().toISOString().split("T")[0],
//       supplier_id: "",
//       return_type: "",
//       enter_amount: "",
//       amount: "",
//       pure: "",
//       opening: "0",
//       current: "0.000",
//       close: "0.000",
//       total_pure: "0.000",
//       total_amount: "0.000",
//       items: [],
//       supplier_details: {
//         supplier_id: "",
//         name: null,
//         mobile: null,
//         address: null,
//       },
//     });
//     resetNewItem();
//     clearSupplier();
//     setSearchTerm("");
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     handleClear();
//     navigate(`/retailer-bill/${formData.retailer_id}`);
//   };

//   const fetchLoggedInUser = () => {
//     try {
//       const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
//       if (userInfo && userInfo.user_id) {
//         setLoggedInUser(userInfo);
//       }
//     } catch (error) {
//       console.error("Error reading logged-in user:", error);
//     }
//   };

//   const fetchUserData = async () => {
//     try {
//       const res = await axios.get(`${ApiUrl}/Api/user.php`);
//       const users = Array.isArray(res.data.data) ? res.data.data : [];
//       setUserdata(users);
//     } catch (err) {
//       console.error("Failed to fetch users", err);
//       toast.error("Failed to load staff data", 3000, 'topRight');
//     }
//   };

//   useEffect(() => {
//     if (!loggedInUser || userdata.length === 0) return;

//     const currentUser = userdata.find(u => u.user_id === loggedInUser.user_id);
//     if (!currentUser) return;

//     if (currentUser.role === "Manager" || currentUser.role === "manager") {
//       setSelectedManager(currentUser.id.toString());
//       setIsManagerLocked(true);

//       const staff = userdata.filter(
//         u => u.manager_id === currentUser.user_id && (u.role === "Employee" || u.role === "employee")
//       );
//       setStaffList(staff);

//       setFormData(prev => ({
//         ...prev,
//         manager: currentUser.user_id,
//         manager_name: currentUser.name,
//       }));
//     }
//     else if (currentUser.role === "Employee" || currentUser.role === "employee") {
//       setSelectedStaff(currentUser.name);
//       setIsStaffLocked(true);

//       const manager = userdata.find(
//         u => u.user_id === currentUser.manager_id && (u.role === "Manager" || u.role === "manager")
//       );

//       if (manager) {
//         setSelectedManager(manager.id.toString());
//         setIsManagerLocked(true);

//         const staffUnderManager = userdata.filter(
//           u => u.manager_id === manager.user_id && (u.role === "Employee" || u.role === "employee")
//         );
//         setStaffList(staffUnderManager);

//         setFormData(prev => ({
//           ...prev,
//           manager: manager.user_id,
//           manager_name: manager.name,
//           staff: currentUser.name,
//         }));
//       }
//     }
//   }, [loggedInUser, userdata]);

//   const handleManagerChange = (e) => {
//     if (isManagerLocked) return;
//     const managerId = e.target.value;
//     setSelectedManager(managerId);
//     setSelectedStaff("");
//     setStaffList([]);

//     if (managerId) {
//       const managerObj = userdata.find(u => u.id === parseInt(managerId));
//       if (managerObj) {
//         const staff = userdata.filter(
//           u => u.manager_id === managerObj.user_id && (u.role === "Employee" || u.role === "employee")
//         );
//         setStaffList(staff);

//         setFormData(prev => ({
//           ...prev,
//           manager: managerObj.user_id,
//           manager_name: managerObj.name,
//         }));
//       }
//     } else {
//       setFormData(prev => ({ ...prev, manager: "", manager_name: "" }));
//     }
//   };

//   const handleStaffChange = (e) => {
//     if (isStaffLocked) return;
//     const staffName = e.target.value;
//     setSelectedStaff(staffName);
//     setFormData(prev => ({ ...prev, staff: staffName }));
//   };

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}
//       <div className="container-fluid py-2">
//         <div className="row">
//           <div className="col-lg-3">
//             <div className="card p-2">
//               <div className="row">
//                 <div className="col-md-6">
//                   <label className="form-label">Retailer ID</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={formData.retailer_id}
//                     readOnly
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     value={formData.retailer_date}
//                     onChange={(e) =>
//                       setFormData((prev) => ({
//                         ...prev,
//                         retailer_date: e.target.value,
//                       }))
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-9">
//             <div className="card p-2">
//               <div className="row g-3">
//                 <div className="col-md-3 position-relative">
//                   <label className="form-label">Supplier</label>
//                   <div className="input-group">
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Search supplier..."
//                       value={searchTerm}
//                       onChange={(e) => {
//                         setSearchTerm(e.target.value);
//                         setShowDropdown(true);
//                       }}
//                       onFocus={() => setShowDropdown(true)}
//                     />
//                     {searchTerm && (
//                       <button
//                         className="btn btn-outline-secondary h-75"
//                         type="button"
//                         onClick={clearSupplier}
//                       >
//                         <i className="bi bi-x"></i>
//                       </button>
//                     )}
//                   </div>

//                   {showDropdown && suppliers.length > 0 && (
//                     <div className="dropdown-menu show w-100">
//                       {suppliers
//                         .filter(
//                           (supplier) =>
//                             supplier.supplier_id
//                               .toLowerCase()
//                               .includes(searchTerm.toLowerCase()) ||
//                             supplier.name
//                               .toLowerCase()
//                               .includes(searchTerm.toLowerCase())
//                         )
//                         .map((supplier) => (
//                           <button
//                             key={supplier.supplier_id}
//                             className="dropdown-item"
//                             onClick={() => handleSelectSupplier(supplier)}
//                             type="button"
//                           >
//                             {supplier.supplier_id} - {supplier.name}
//                           </button>
//                         ))}
//                     </div>
//                   )}
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Supplier Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     value={
//                       formData.supplier_details?.name ||
//                       selectedSupplier?.name ||
//                       ""
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Mobile</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     value={
//                       formData.supplier_details?.mobile ||
//                       selectedSupplier?.mobile ||
//                       ""
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Address</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     value={
//                       formData.supplier_details?.address ||
//                       selectedSupplier?.address ||
//                       ""
//                     }
//                     disabled
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="row mt-3">
//           <div className="col-md-3">
//             <label className="form-label">
//               Manager <span className="text-danger">*</span>
//             </label>
//             <select
//               className="form-select"
//               value={selectedManager}
//               onChange={handleManagerChange}
//               disabled={isManagerLocked}
//             >
//               <option value="">Select Manager</option>
//               {userdata
//                 .filter(u => u.role === "Manager" || u.role === "manager")
//                 .map(manager => (
//                   <option key={manager.id} value={manager.id}>
//                     {manager.name}
//                   </option>
//                 ))}
//             </select>
//           </div>

//           <div className="col-md-3">
//             <label className="form-label">
//               Staff <span className="text-danger">*</span>
//             </label>
//             <select
//               className="form-select"
//               value={selectedStaff}
//               onChange={handleStaffChange}
//               disabled={isStaffLocked || !selectedManager}
//             >
//               <option value="">Select Staff</option>
//               {staffList.map(staff => (
//                 <option key={staff.id} value={staff.name}>
//                   {staff.name}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>

//         <div className="card p-2 mt-1">
//           <div className="row g-3">
//             <div className="col-md-2">
//               <label className="form-label">Item</label>
//               <select
//                 className="form-select"
//                 value={newItem.item}
//                 onChange={(e) =>
//                   setNewItem({
//                     ...newItem,
//                     item: e.target.value,
//                     type: e.target.value === "Bar" ? "" : newItem.type,
//                   })
//                 }
//               >
//                 <option value="">Select Item</option>
//                 <option value="Bar">Bar</option>
//                 <option value="Jewels">Jewels</option>
//                 <option value="Others">Others</option>
//               </select>
//             </div>

//             {newItem.item === "Others" && (
//               <div className="col-md-2">
//                 <label className="form-label">Others Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Others Name"
//                   value={newItem.other_name}
//                   onChange={(e) =>
//                     setNewItem({ ...newItem, other_name: e.target.value })
//                   }
//                 />
//               </div>
//             )}

//             <div className="col-md-1">
//               <label className="form-label">Category</label>
//               <select
//                 className="form-select"
//                 value={newItem.category}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, category: e.target.value })
//                 }
//               >
//                 <option value="">Select Category</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//               </select>
//             </div>
//             <div className="col-md-2">
//               <label className="form-label">Type</label>
//               <select
//                 className="form-select"
//                 value={newItem.type}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, type: e.target.value })
//                 }
//                 disabled={newItem.item === "Bar"}
//               >
//                 <option value="">Select Type</option>
//                 {Array.isArray(productTypes) &&
//                   productTypes.map((item) => (
//                     <option key={item._id} value={item.type}>
//                       {item.type}
//                     </option>
//                   ))}
//               </select>
//             </div>

//             <div className="col-md-1">
//               <label className="form-label">Weight (g)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Weight"
//                 value={newItem.weight}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d*$/.test(value)) {
//                     setNewItem({ ...newItem, weight: value });
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-1">
//               <label className="form-label">Purity (%)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Purity"
//                 value={newItem.purity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d{0,3}(\.\d{0,2})?$/.test(value)) {
//                     const numericValue = parseFloat(value);
//                     if (
//                       value === "" ||
//                       (!isNaN(numericValue) && numericValue <= 100)
//                     ) {
//                       setNewItem({ ...newItem, purity: value });
//                     } else {
//                       toast.error("Purity cannot exceed 100%", 3000, "topRight");
//                     }
//                   }
//                 }}
//               />
//             </div>

//             {/* NEW: Exact same adjustment input as in AddPurchase */}
//             <div className="col-md-2 position-relative">
//               <label className="form-label">Adjustment (g)</label>
//               <div className="input-group">
//                 <button
//                   className="btn btn-outline-danger btn-sm"
//                   type="button"
//                   style={{ height: "30px" }}
//                   onClick={() => {
//                     const v = parseFloat(adjustmentInput) || 0;
//                     if (v > 0) {
//                       setNewItem(prev => ({
//                         ...prev,
//                         adjustment: (parseFloat(prev.adjustment || 0) - v).toFixed(3)
//                       }));
//                       setAdjustmentInput("");
//                     }
//                   }}
//                 >
//                   <i className="fa-solid fa-minus"></i>
//                 </button>

//                 <input
//                   type="text"
//                   className="form-control form-control-sm text-center"
//                   placeholder="0.000"
//                   style={{ width: "80px" }}
//                   value={adjustmentInput}
//                   onChange={(e) => {
//                     if (/^\d*\.?\d*$/.test(e.target.value)) {
//                       setAdjustmentInput(e.target.value);
//                     }
//                   }}
//                   onKeyPress={(e) => {
//                     if (e.key === "Enter") {
//                       const v = parseFloat(adjustmentInput) || 0;
//                       if (v > 0) {
//                         setNewItem(prev => ({
//                           ...prev,
//                           adjustment: (parseFloat(prev.adjustment || 0) + v).toFixed(3)
//                         }));
//                         setAdjustmentInput("");
//                       }
//                     }
//                   }}
//                 />

//                 <button
//                   className="btn btn-outline-success btn-sm"
//                   type="button"
//                   style={{ height: "30px" }}
//                   onClick={() => {
//                     const v = parseFloat(adjustmentInput) || 0;
//                     if (v > 0) {
//                       setNewItem(prev => ({
//                         ...prev,
//                         adjustment: (parseFloat(prev.adjustment || 0) + v).toFixed(3)
//                       }));
//                       setAdjustmentInput("");
//                     }
//                   }}
//                 >
//                   <i className="fa-solid fa-plus"></i>
//                 </button>

//                 {/* Tiny × button */}
//                 {parseFloat(newItem.adjustment || 0) !== 0 && (
//                   <button
//                     type="button"
//                     className="position-absolute text-danger fw-bold"
//                     style={{
//                       top: "30px",
//                       right: "45px",
//                       background: "none",
//                       border: "none",
//                       fontSize: "18px",
//                       zIndex: 10,
//                     }}
//                     onClick={() => {
//                       setNewItem(prev => ({ ...prev, adjustment: "0.000" }));
//                       setAdjustmentInput("");
//                     }}
//                   >
//                     ×
//                   </button>
//                 )}
//               </div>

//               {/* Show current adjustment value */}
//               {parseFloat(newItem.adjustment || 0) !== 0 && (
//                 <small
//                   className={`d-block text-center mt-1 fw-bold ${parseFloat(newItem.adjustment) > 0 ? "text-success" : "text-danger"
//                     }`}
//                 >
//                   {parseFloat(newItem.adjustment) > 0 ? "+" : ""}
//                   {newItem.adjustment}g
//                 </small>
//               )}
//             </div>

//             <div className="col-md-1">
//               <label className="form-label">Pure (g)</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 value={newItem.pure || "0.000"}
//                 readOnly
//               />
//             </div>

//             <div className="col-md-1">
//               {editingItemId === null ? (
//                 <button
//                   className="btn btn-success btn-sm mx-2 mt-4"
//                   onClick={handleAddItem}
//                 >
//                   <i className="bi bi-plus"></i>
//                 </button>
//               ) : (
//                 <button
//                   className="btn btn-info btn-sm mx-2 mt-4"
//                   onClick={handleUpdateItem}
//                 >
//                   <i className="bi bi-check"></i>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="container-fluid p-2">
//           <div className="row">
//             <div className="col-lg-9">
//               <div className="card card-body p-2">
//                 <h6>Item List</h6>
//                 <div className="p-2" style={{ backgroundColor: "#E8F0FA" }}>
//                   <div className="table-container">
//                     <table className="table table-layout-fixed w-100">
//                       <thead className="bg-light">
//                         <tr>
//                           <th>S.No</th>
//                           <th>Item</th>
//                           <th>Category</th>
//                           <th>Type</th>
//                           <th>Weight(g)</th>
//                           <th>Purity (%)</th>
//                           <th>Pure(g)</th>
//                           <th>Adjustment(g)</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {formData.items.length > 0 ? (
//                           formData.items.map((item, index) => (
//                             <tr key={index}>
//                               <td>{index + 1}</td>
//                               <td>
//                                 {item.item}
//                                 {item.other_name ? ` (${item.other_name})` : ""}
//                               </td>
//                               <td>{item.category}</td>
//                               <td>{item.type || "-"}</td>
//                               <td>{item.weight}g</td>
//                               <td>{item.purity}%</td>
//                               <td>{parseFloat(item.pure).toFixed(3)}g</td>
//                               <td className="text-center">
//                                 {parseFloat(item.adjustment || 0) !== 0 ? (
//                                   <span
//                                     className={`fw-bold ${parseFloat(item.adjustment) > 0 ? "text-success" : "text-danger"
//                                       }`}
//                                   >
//                                     {parseFloat(item.adjustment) > 0 ? "+" : ""}
//                                     {/* parseFloat(item.adjustment).toFixed(3),"g" */}
//                                   </span>
//                                 ) : (
//                                   <span className="text-muted">—</span>
//                                 )}
//                               </td>
//                               <td>
//                                 <button
//                                   className="btn btn-sm btn-light me-1"
//                                   onClick={() => handleEditItem(item.id)}
//                                 >
//                                   <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
//                                 </button>
//                                 <button
//                                   className="btn btn-sm btn-light me-1"
//                                   onClick={() => handleRemoveItem(item.id)}
//                                 >
//                                   <i className="fa-solid fa-trash text-danger fs-6"></i>
//                                 </button>
//                               </td>
//                             </tr>
//                           )
//                         )) : (
//                           <tr>
//                             <td colSpan="9" className="text-center">
//                               No items added yet
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="col-lg-3">
//               <div className="card p-3">
//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Total Pure (g)</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={formData.total_pure || "0.000"}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Return Type</label>
//                   </div>
//                   <div className="col-md-6">
//                     <select
//                       className="form-select"
//                       value={formData.return_type || ""}
//                       onChange={(e) =>
//                         setFormData({
//                           ...formData,
//                           return_type: e.target.value,
//                           enter_amount: e.target.value === "Amount" ? formData.enter_amount : "",
//                           amount: e.target.value === "Amount" ? formData.amount : "",
//                           pure: e.target.value === "Pure" ? formData.pure : "",
//                         })
//                       }
//                     >
//                       <option value="">Select Type</option>
//                       <option value="Pure">Pure</option>
//                       <option value="Amount">Amount</option>
//                     </select>
//                   </div>
//                 </div>

//                 {formData.return_type === "Pure" && (
//                   <div className="row mb-3">
//                     <div className="col-md-6">
//                       <label className="form-label">Pure (g)</label>
//                     </div>
//                     <div className="col-md-6">
//                       <input
//                         type="text"
//                         inputMode="decimal"
//                         className="form-control"
//                         value={formData.pure || ""}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d*\.?\d*$/.test(value)) {
//                             const numericValue = parseFloat(value);
//                             const current = parseFloat(formData.current) || 0;
//                             if (
//                               value === "" ||
//                               (!isNaN(numericValue) && numericValue >= 0 && numericValue <= current)
//                             ) {
//                               setFormData({ ...formData, pure: value });
//                             } else {
//                               toast.error(
//                                 "Pure value must be between 0 and Current",
//                                 3000,
//                                 "topRight"
//                               );
//                             }
//                           }
//                         }}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 {formData.return_type === "Amount" && (
//                   <div className="row mb-3">
//                     <div className="col-md-6">
//                       <label className="form-label">Enter Amount</label>
//                     </div>
//                     <div className="col-md-6">
//                       <input
//                         type="text"
//                         inputMode="decimal"
//                         className="form-control"
//                         value={formData.enter_amount || ""}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d*\.?\d*$/.test(value)) {
//                             setFormData({ ...formData, enter_amount: value });
//                           }
//                         }}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 {formData.return_type === "Amount" && (
//                   <div className="row mb-3">
//                     <div className="col-md-6">
//                       <label className="form-label">Paid</label>
//                     </div>
//                     <div className="col-md-6">
//                       <input
//                         type="text"
//                         inputMode="decimal"
//                         className="form-control"
//                         value={formData.amount || ""}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d*\.?\d*$/.test(value)) {
//                             const numericValue = parseFloat(value);
//                             const current = parseFloat(formData.current) || 0;
//                             if (
//                               value === "" ||
//                               (!isNaN(numericValue) && numericValue >= 0 && numericValue <= current)
//                             ) {
//                               setFormData({ ...formData, amount: value });
//                             } else {
//                               toast.error(
//                                 "Paid value cannot exceed Current",
//                                 3000,
//                                 "topRight"
//                               );
//                             }
//                           }
//                         }}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Opening</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={formData.opening || "0"}
//                       readOnly
//                       style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     />
//                   </div>
//                 </div>
//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Current</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={formData.current || "0.000"}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Closing</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={formData.close || "0.000"}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="d-flex justify-content-between mt-2">
//                   <button
//                     className="btn btn-secondary btn-sm"
//                     onClick={() => navigate("/retailers")}
//                   >
//                     <i className="fa-solid fa-arrow-left"></i> Back
//                   </button>
//                   <button
//                     className="btn btn-danger btn-sm"
//                     onClick={handleClear}
//                   >
//                     <i className="bi bi-x-circle"></i> Clear
//                   </button>
//                   <button
//                     className="btn btn-primary btn-sm"
//                     onClick={handlePrint}
//                     disabled={loading}
//                   >
//                     <i className="bi bi-printer"></i> Print
//                   </button>
//                   <button
//                     className="btn btn-success btn-sm"
//                     onClick={handleSave}
//                     disabled={loading}
//                   >
//                     <i className="bi bi-save"></i> Save
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Modal and backdrop remain unchanged */}
//         <div
//           className={`modal fade ${showModal ? "show" : ""}`}
//           style={{ display: showModal ? "block" : "none" }}
//           tabIndex="-1"
//           aria-labelledby="printModalLabel"
//           aria-hidden={!showModal}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h6 className="modal-title text-primary" id="printModalLabel">
//                   Print Confirmation
//                 </h6>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   style={{ fontSize: "10px" }}
//                   onClick={() => setShowModal(false)}
//                   aria-label="Close"
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <div className="text-center">
//                   <p>Do you want to print the retailer bill?</p>
//                 </div>
//                 <div className="d-flex justify-content-center mt-4">
//                   <button
//                     type="button"
//                     className="btn btn-secondary btn-sm mx-2"
//                     onClick={() => navigate("/retailers")}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-primary btn-sm"
//                     onClick={handlePrint}
//                     disabled={loading}
//                   >
//                     {loading ? "Processing..." : "Print"}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {showModal && <div className="modal-backdrop fade show"></div>}
//       </div>
//     </>
//   );
// }

// export default UpdateRetailer;

// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import ApiUrl from "../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext";

// function UpdateRetailer({ toggleSidebar }) {
//   const { id } = useParams();
//   const toast = useToast();
//   const navigate = useNavigate();
//   const [showModal, setShowModal] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [productTypes, setProductTypes] = useState([]);
//   const [suppliers, setSuppliers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedSupplier, setSelectedSupplier] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [editingItemId, setEditingItemId] = useState(null);
//   const [generateNumber, setGenerateNumber] = useState("");
//   const [userdata, setUserdata] = useState([]);
//   const [loggedInUser, setLoggedInUser] = useState(null);
//   const [selectedManager, setSelectedManager] = useState("");
//   const [selectedStaff, setSelectedStaff] = useState("");
//   const [staffList, setStaffList] = useState([]);
//   const [isManagerLocked, setIsManagerLocked] = useState(false);
//   const [isStaffLocked, setIsStaffLocked] = useState(false);
//   const [adjustmentInput, setAdjustmentInput] = useState("");

//   const [formData, setFormData] = useState({
//     retailer_id: "",
//     retailer_date: "",
//     supplier_id: "",
//     return_type: "",
//     enter_amount: "",
//     amount: "",
//     pure: "",
//     opening: "0.000",
//     current: "0.000",
//     close: "0.000",
//     total_pure: "0.000",
//     manager: "",
//     manager_name: "",
//     staff: "",
//     items: [],
//     supplier_details: {
//       supplier_id: "",
//       name: null,
//       mobile: null,
//       address: null,
//     },
//   });

//   const [newItem, setNewItem] = useState({
//     item: "",
//     category: "",
//     other_name: "",
//     type: "",
//     quantity: 1,
//     weight: "",
//     purity: "",
//     pure: "0.000",
//     total_amount: "0.000",
//     adjustment: "0.000",
//   });

//   useEffect(() => {
//     if (toggleSidebar) toggleSidebar();
//     fetchUserData();
//     fetchLoggedInUser();
//     fetchInitialData();
//   }, [id]);

//   const fetchInitialData = async () => {
//     try {
//       setLoading(true);
//       const typeResponse = await axios.get(`${ApiUrl}/Api/product_type.php`);
//       setProductTypes(typeResponse.data?.data || []);

//       const supplierResponse = await axios.get(`${ApiUrl}/Api/supplier.php`);
//       setSuppliers(supplierResponse.data?.data || []);

//       const retailerResponse = await axios.get(
//         `${ApiUrl}/Api/retailer_details.php/${id}`
//       );
//       if (!retailerResponse.data || !Array.isArray(retailerResponse.data.data)) {
//         throw new Error("Invalid response format");
//       }

//       const retailer = retailerResponse.data.data.find((r) => r.id === id);
//       if (!retailer) {
//         throw new Error(`Retailer with ID ${id} not found`);
//       }

//       const formattedItems = Array.isArray(retailer.items)
//         ? retailer.items.map((item, index) => {
//           const weight = parseFloat(item.weight || 0);
//           const purity = parseFloat(item.percentage || item.purity || 0);
//           const quantity = parseFloat(item.quantity || 0);
//           const singlePure =
//             !isNaN(weight) && !isNaN(purity)
//               ? (weight * purity) / 100
//               : 0;
//           const pure = (quantity * singlePure).toFixed(3);
//           const total_amount = pure;
//           return {
//             id: item.id || (index + 1).toString(),
//             retailer_id: retailer.retailer_id || "",
//             item: item.item_name || item.item || "",
//             category: item.category || "",
//             other_name: item.other_name || "",
//             type: item.type || "",
//             quantity: item.quantity || "",
//             weight: item.weight || "",
//             purity: item.percentage || item.purity || "",
//             pure,
//             total_amount,
//             adjustment: parseFloat(item.adjustment || 0).toFixed(3), // ← Load saved adjustment
//           };
//         })
//         : [];

//       setGenerateNumber(retailer.retailer_id || "");
//       const openingValue = parseFloat(retailer.opening || "0");
//       setFormData({
//         retailer_id: retailer.retailer_id || "",
//         retailer_date: retailer.retailer_date || new Date().toISOString().split("T")[0],
//         supplier_id: retailer.supplier_id || "",
//         return_type: retailer.return_type || "Amount",
//         enter_amount: parseFloat(retailer.enter_amount || "55000").toFixed(3),
//         amount: parseFloat(retailer.amount || "25000").toFixed(3),
//         pure: retailer.pure ? parseFloat(retailer.pure).toFixed(3) : "",
//         opening: openingValue === 0 ? "0" : openingValue.toFixed(3),
//         current: parseFloat(retailer.current || "55000").toFixed(3),
//         close: parseFloat(retailer.close || "30000").toFixed(3),
//         total_pure: parseFloat(retailer.total_pure || 0).toFixed(3),
//         total_amount: parseFloat(retailer.total_amount || 0).toFixed(3),
//         items: formattedItems,
//         supplier_details: {
//           supplier_id: retailer.supplier_id || "",
//           name: retailer.supplier_details?.name || null,
//           mobile: retailer.supplier_details?.mobile || null,
//           address: retailer.supplier_details?.address || null,
//         },
//       });

//       if (retailer.supplier_id) {
//         setSearchTerm(
//           `${retailer.supplier_id} - ${retailer.supplier_details?.name || ""}`
//         );
//         setSelectedSupplier({
//           supplier_id: retailer.supplier_id,
//           name: retailer.supplier_details?.name || "",
//           mobile: retailer.supplier_details?.mobile || "",
//           address: retailer.supplier_details?.address || "",
//         });
//       }
//     } catch (error) {
//       console.error("Initialization error:", error);
//       toast.error("Failed to initialize form data", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Pure calculation for new item
//   useEffect(() => {
//     let pure = "0.000";
//     let total_amount = "0.000";

//     if (newItem.weight && newItem.purity && newItem.quantity) {
//       const weight = parseFloat(newItem.weight) || 0;
//       const purity = parseFloat(newItem.purity) || 0;
//       const quantity = parseFloat(newItem.quantity) || 1;

//       if (purity > 100) {
//         toast.error("Purity cannot exceed 100%", 3000, "topRight");
//         setNewItem(prev => ({ ...prev, purity: "" }));
//         return;
//       }

//       const singlePure = (weight * purity) / 100;
//       let calculatedPure = quantity * singlePure;
//       calculatedPure += parseFloat(newItem.adjustment) || 0;

//       pure = calculatedPure.toFixed(3);
//       total_amount = (quantity * singlePure).toFixed(3);
//     }

//     setNewItem(prev => ({ ...prev, pure, total_amount }));
//   }, [newItem.weight, newItem.purity, newItem.quantity, newItem.adjustment]);

//   // Total pure
//   useEffect(() => {
//     const totalPure = formData.items.reduce((sum, item) => sum + parseFloat(item.pure || 0), 0).toFixed(3);
//     setFormData(prev => ({ ...prev, total_pure: totalPure }));
//   }, [formData.items]);

//   // Current calculation
//   useEffect(() => {
//     const opening = parseFloat(formData.opening) || 0;
//     let current = opening;

//     if (formData.return_type === "Amount") {
//       current += parseFloat(formData.enter_amount) || 0;
//     } else if (formData.return_type === "Pure") {
//       current += parseFloat(formData.total_pure) || 0;
//     }

//     setFormData(prev => ({ ...prev, current: current.toFixed(3) }));
//   }, [formData.opening, formData.total_pure, formData.enter_amount, formData.return_type]);

//   // Closing calculation
//   useEffect(() => {
//     const current = parseFloat(formData.current) || 0;
//     let close = current;

//     if (formData.return_type === "Pure") {
//       close -= parseFloat(formData.pure) || 0;
//     } else if (formData.return_type === "Amount") {
//       close -= parseFloat(formData.amount) || 0;
//     }

//     setFormData(prev => ({ ...prev, close: close.toFixed(3) }));
//   }, [formData.current, formData.pure, formData.amount, formData.return_type]);

//   // Simplified opening balance
//   const fetchOpeningBalance = async (supplierId) => {
//     if (!supplierId || !formData.return_type) {
//       setFormData(prev => ({ ...prev, opening: "0.000" }));
//       return;
//     }

//     try {
//       const res = await axios.get(`${ApiUrl}/Api/retailer_details.php`);
//       const all = res.data?.data || [];

//       const relevant = all
//         .filter(r => r.supplier_id === supplierId && r.return_type === formData.return_type)
//         .sort((a, b) => new Date(b.retailer_date) - new Date(a.retailer_date));

//       const opening = relevant.length > 0 ? parseFloat(relevant[0].close || 0).toFixed(3) : "0.000";
//       setFormData(prev => ({ ...prev, opening }));
//     } catch (err) {
//       setFormData(prev => ({ ...prev, opening: "0.000" }));
//     }
//   };

//   useEffect(() => {
//     if (selectedSupplier?.supplier_id) {
//       fetchOpeningBalance(selectedSupplier.supplier_id);
//     }
//   }, [selectedSupplier, formData.return_type]);

//   const handleSelectSupplier = async (supplier) => {
//     setSelectedSupplier(supplier);
//     setSearchTerm(`${supplier.supplier_id} - ${supplier.name}`);
//     setFormData(prev => ({
//       ...prev,
//       supplier_id: supplier.supplier_id,
//       supplier_details: { ...supplier },
//       opening: "0.000",
//     }));
//     setShowDropdown(false);
//     await fetchOpeningBalance(supplier.supplier_id);
//   };

//   const clearSupplier = () => {
//     setSelectedSupplier(null);
//     setSearchTerm("");
//     setFormData(prev => ({
//       ...prev,
//       supplier_id: "",
//       supplier_details: { supplier_id: "", name: null, mobile: null, address: null },
//       opening: "0.000",
//     }));
//   };

//   const validateItem = () => {
//     if (!newItem.item) return toast.error("Select item", 3000, "topRight"), false;
//     if (!newItem.category) return toast.error("Select category", 3000, "topRight"), false;
//     if (newItem.item !== "Bar" && !newItem.type) return toast.error("Select type", 3000, "topRight"), false;
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) return toast.error("Valid quantity required", 3000, "topRight"), false;
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0) return toast.error("Valid weight required", 3000, "topRight"), false;
//     if (!newItem.purity || parseFloat(newItem.purity) <= 0 || parseFloat(newItem.purity) > 100) return toast.error("Valid purity (0-100%)", 3000, "topRight"), false;
//     if (newItem.item === "Others" && !newItem.other_name) return toast.error("Enter name for Others", 3000, "topRight"), false;
//     return true;
//   };

//   const handleAddItem = () => {
//     if (!validateItem()) return;
//     const newItems = [...formData.items, { ...newItem, id: formData.items.length + 1 }];
//     setFormData(prev => ({ ...prev, items: newItems }));
//     resetNewItem();
//   };

//   const handleUpdateItem = () => {
//     if (!validateItem() || editingItemId === null) return;
//     const updated = formData.items.map(item =>
//       item.id === editingItemId ? { ...newItem, id: item.id } : item
//     );
//     setFormData(prev => ({ ...prev, items: updated }));
//     resetNewItem();
//   };

//   const handleEditItem = (id) => {
//     const item = formData.items.find(i => i.id === id);
//     if (item) {
//       setNewItem({ ...item, quantity: item.quantity.toString(), weight: item.weight.toString(), purity: item.purity.toString() });
//       setAdjustmentInput("");
//       setEditingItemId(id);
//     }
//   };

//   const handleRemoveItem = (id) => {
//     const filtered = formData.items.filter(i => i.id !== id).map((i, idx) => ({ ...i, id: idx + 1 }));
//     setFormData(prev => ({ ...prev, items: filtered }));
//   };

//   const resetNewItem = () => {
//     setNewItem({
//       item: "", category: "", other_name: "", type: "", quantity: 1,
//       weight: "", purity: "", pure: "0.000", total_amount: "0.000", adjustment: "0.000"
//     });
//     setAdjustmentInput("");
//     setEditingItemId(null);
//   };

//   const validateForm = () => {
//     if (!formData.supplier_id) return toast.error("Select supplier", 3000, "topRight"), false;
//     if (formData.items.length === 0) return toast.error("Add at least one item", 3000, "topRight"), false;
//     if (!formData.return_type) return toast.error("Select return type", 3000, "topRight"), false;
//     if (formData.return_type === "Pure" && parseFloat(formData.pure) <= 0) return toast.error("Enter valid pure return", 3000, "topRight"), false;
//     if (formData.return_type === "Amount" && (!formData.amount || parseFloat(formData.amount) <= 0)) return toast.error("Enter valid paid amount", 3000, "topRight"), false;
//     if (!formData.manager) return toast.error("Select manager", 3000, "topRight"), false;
//     if (!formData.staff) return toast.error("Select staff", 3000, "topRight"), false;
//     return true;
//   };

//   const preparePayload = () => {
//     const payload = {
//       id,
//       retailer_id: formData.retailer_id,
//       retailer_date: formData.retailer_date,
//       supplier_id: formData.supplier_id,
//       return_type: formData.return_type,
//       enter_amount: parseFloat(formData.enter_amount) || 0,
//       amount: parseFloat(formData.amount) || 0,
//       pure: parseFloat(formData.pure) || 0,
//       opening: parseFloat(formData.opening) || 0,
//       current: parseFloat(formData.current) || 0,
//       close: parseFloat(formData.close) || 0,
//       total_pure: parseFloat(formData.total_pure) || 0,
//       manager: formData.manager || "",
//       manager_name: formData.manager_name || "",
//       staff: formData.staff || "",
//       items: formData.items.map(i => ({
//         category: i.category,
//         quantity: i.quantity,
//         item: i.item,
//         weight: i.weight,
//         type: i.type || "",
//         other_name: i.other_name || "",
//         percentage: i.purity,
//         pure: i.pure,
//         total_amount: i.total_amount,
//         adjustment: i.adjustment,
//       })),
//     };

//     if (formData.return_type === "Pure") {
//       payload.enter_amount = 0;
//       payload.amount = 0;
//     } else if (formData.return_type === "Amount") {
//       payload.pure = 0;
//     }

//     return payload;
//   };

//   const handleSave = async () => {
//     if (!validateForm()) return;
//     try {
//       setLoading(true);
//       const payload = preparePayload();
//       await axios.put(`${ApiUrl}/Api/retailer_details.php`, payload);
//       toast.success("Retailer updated!", 3000, "topRight");
//       navigate("/retailers");
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Update failed", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePrint = async () => {
//     if (!validateForm()) return;
//     try {
//       setLoading(true);
//       const payload = preparePayload();
//       await axios.put(`${ApiUrl}/Api/retailer_details.php`, payload);
//       toast.success("Updated for print", 3000, "topRight");
//       navigate(`/retailer-bill/${formData.retailer_id}`);
//     } catch (err) {
//       toast.error("Print failed", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchLoggedInUser = () => {
//     try {
//       const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
//       if (userInfo?.user_id) setLoggedInUser(userInfo);
//     } catch (error) {
//       console.error("Error reading user:", error);
//     }
//   };

//   const fetchUserData = async () => {
//     try {
//       const res = await axios.get(`${ApiUrl}/Api/user.php`);
//       setUserdata(Array.isArray(res.data.data) ? res.data.data : []);
//     } catch (err) {
//       toast.error("Failed to load staff data", 3000, "topRight");
//     }
//   };

//   useEffect(() => {
//     if (!loggedInUser || userdata.length === 0) return;
//     const currentUser = userdata.find(u => u.user_id === loggedInUser.user_id);
//     if (!currentUser) return;

//     if (currentUser.role.toLowerCase() === "manager") {
//       setSelectedManager(currentUser.id.toString());
//       setIsManagerLocked(true);
//       const staff = userdata.filter(u => u.manager_id === currentUser.user_id && u.role.toLowerCase() === "employee");
//       setStaffList(staff);
//       setFormData(prev => ({ ...prev, manager: currentUser.user_id, manager_name: currentUser.name }));
//     } else if (currentUser.role.toLowerCase() === "employee") {
//       setSelectedStaff(currentUser.name);
//       setIsStaffLocked(true);
//       const manager = userdata.find(u => u.user_id === currentUser.manager_id && u.role.toLowerCase() === "manager");
//       if (manager) {
//         setSelectedManager(manager.id.toString());
//         setIsManagerLocked(true);
//         const staffUnder = userdata.filter(u => u.manager_id === manager.user_id && u.role.toLowerCase() === "employee");
//         setStaffList(staffUnder);
//         setFormData(prev => ({ ...prev, manager: manager.user_id, manager_name: manager.name, staff: currentUser.name }));
//       }
//     }
//   }, [loggedInUser, userdata]);

//   const handleManagerChange = (e) => {
//     if (isManagerLocked) return;
//     const managerId = e.target.value;
//     setSelectedManager(managerId);
//     setSelectedStaff("");
//     setStaffList([]);
//     if (managerId) {
//       const managerObj = userdata.find(u => u.id === parseInt(managerId));
//       if (managerObj) {
//         const staff = userdata.filter(u => u.manager_id === managerObj.user_id && u.role.toLowerCase() === "employee");
//         setStaffList(staff);
//         setFormData(prev => ({ ...prev, manager: managerObj.user_id, manager_name: managerObj.name }));
//       }
//     } else {
//       setFormData(prev => ({ ...prev, manager: "", manager_name: "" }));
//     }
//   };

//   const handleStaffChange = (e) => {
//     if (isStaffLocked) return;
//     const staffName = e.target.value;
//     setSelectedStaff(staffName);
//     setFormData(prev => ({ ...prev, staff: staffName }));
//   };

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}

//       <div className="container-fluid py-2">
//         <div className="row">
//           <div className="col-lg-3">
//             <div className="card p-2">
//               <div className="row">
//                 <div className="col-md-6">
//                   <label className="form-label">Retailer ID</label>
//                   <input type="text" className="form-control" value={generateNumber} readOnly />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     value={formData.retailer_date}
//                     onChange={(e) => setFormData(prev => ({ ...prev, retailer_date: e.target.value }))}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-9">
//             <div className="card p-2">
//               <div className="row g-3">
//                 <div className="col-md-3 position-relative">
//                   <label className="form-label">Supplier</label>
//                   <div className="input-group">
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Search supplier..."
//                       value={searchTerm}
//                       onChange={(e) => { setSearchTerm(e.target.value); setShowDropdown(true); }}
//                       onFocus={() => setShowDropdown(true)}
//                     />
//                     {searchTerm && (
//                       <button className="btn btn-outline-secondary" onClick={clearSupplier}>
//                         <i className="bi bi-x"></i>
//                       </button>
//                     )}
//                   </div>
//                   {showDropdown && suppliers.length > 0 && (
//                     <div className="dropdown-menu show w-100">
//                       {suppliers
//                         .filter(s => s.supplier_id.toLowerCase().includes(searchTerm.toLowerCase()) || s.name.toLowerCase().includes(searchTerm.toLowerCase()))
//                         .map(s => (
//                           <button key={s.supplier_id} className="dropdown-item" onClick={() => handleSelectSupplier(s)} type="button">
//                             {s.supplier_id} - {s.name}
//                           </button>
//                         ))}
//                     </div>
//                   )}
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Name</label>
//                   <input type="text" className="form-control" value={formData.supplier_details?.name || ""} disabled style={{ backgroundColor: "#f0f0f0" }} />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Mobile</label>
//                   <input type="text" className="form-control" value={formData.supplier_details?.mobile || ""} disabled style={{ backgroundColor: "#f0f0f0" }} />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Address</label>
//                   <input type="text" className="form-control" value={formData.supplier_details?.address || ""} disabled style={{ backgroundColor: "#f0f0f0" }} />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="row mt-3">
//           <div className="col-md-3">
//             <label className="form-label">Manager <span className="text-danger">*</span></label>
//             <select className="form-select" value={selectedManager} onChange={handleManagerChange} disabled={isManagerLocked}>
//               <option value="">Select Manager</option>
//               {userdata.filter(u => u.role.toLowerCase() === "manager").map(m => (
//                 <option key={m.id} value={m.id}>{m.name}</option>
//               ))}
//             </select>
//           </div>
//           <div className="col-md-3">
//             <label className="form-label">Staff <span className="text-danger">*</span></label>
//             <select className="form-select" value={selectedStaff} onChange={handleStaffChange} disabled={isStaffLocked || !selectedManager}>
//               <option value="">Select Staff</option>
//               {staffList.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
//             </select>
//           </div>
//         </div>

//         <div className="card p-2 mt-1">
//           <div className="row g-3">
//             <div className="col-md-2">
//               <label>Item</label>
//               <select className="form-select" value={newItem.item} onChange={e => setNewItem({ ...newItem, item: e.target.value, type: e.target.value === "Bar" ? "" : newItem.type })}>
//                 <option value="">Select</option>
//                 <option value="Bar">Bar</option>
//                 <option value="Jewels">Jewels</option>
//                 <option value="Others">Others</option>
//               </select>
//             </div>
//             {newItem.item === "Others" && (
//               <div className="col-md-2">
//                 <label>Others Name</label>
//                 <input type="text" className="form-control" value={newItem.other_name} onChange={e => setNewItem({ ...newItem, other_name: e.target.value })} />
//               </div>
//             )}
//             <div className="col-md-2">
//               <label>Category</label>
//               <select className="form-select" value={newItem.category} onChange={e => setNewItem({ ...newItem, category: e.target.value })}>
//                 <option value="">Select</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//               </select>
//             </div>
//             <div className="col-md-2">
//               <label>Type</label>
//               <select className="form-select" value={newItem.type} onChange={e => setNewItem({ ...newItem, type: e.target.value })} disabled={newItem.item === "Bar"}>
//                 <option value="">Select</option>
//                 {productTypes.map(t => <option key={t._id} value={t.type}>{t.type}</option>)}
//               </select>
//             </div>
//             {/* <div className="col-md-1">
//               <label>Qty</label>
//               <input type="text" className="form-control" value={newItem.quantity} onChange={e => /^\d*$/.test(e.target.value) && setNewItem({ ...newItem, quantity: e.target.value || "1" })} />
//             </div> */}
//             <div className="col-md-1">
//               <label>Weight (g)</label>
//               <input type="text" className="form-control" value={newItem.weight} onChange={e => /^\d*\.?\d*$/.test(e.target.value) && setNewItem({ ...newItem, weight: e.target.value })} />
//             </div>
//             <div className="col-md-2 position-relative">
//               <label>Adjustment</label>
//               <div className="input-group">
//                 <button className="btn btn-outline-danger btn-sm" type="button" style={{height:"30px"}} onClick={() => {
//                   const v = parseFloat(adjustmentInput) || 0;
//                   if (v > 0) { setNewItem(p => ({ ...p, adjustment: (parseFloat(p.adjustment || 0) - v).toFixed(3) })); setAdjustmentInput(""); }
//                 }}><i className="fa-solid fa-minus"></i></button>
//                 <input type="text" className="form-control form-control-sm text-center" value={adjustmentInput} placeholder="0.000"
//                   onChange={e => /^\d*\.?\d*$/.test(e.target.value) && setAdjustmentInput(e.target.value)}
//                   onKeyPress={e => e.key === "Enter" && (parseFloat(adjustmentInput) || 0) > 0 && (setNewItem(p => ({ ...p, adjustment: (parseFloat(p.adjustment || 0) + parseFloat(adjustmentInput)).toFixed(3) })), setAdjustmentInput(""))} />
//                 <button className="btn btn-outline-success btn-sm" type="button" style={{height:"30px"}} onClick={() => {
//                   const v = parseFloat(adjustmentInput) || 0;
//                   if (v > 0) { setNewItem(p => ({ ...p, adjustment: (parseFloat(p.adjustment || 0) + v).toFixed(3) })); setAdjustmentInput(""); }
//                 }}><i className="fa-solid fa-plus"></i></button>
//                 {parseFloat(newItem.adjustment || 0) !== 0 && (
//                   <button className="btn btn-sm position-absolute end-0 top-50 translate-middle-y me-1" style={{ zIndex: 10, background: "none", border: "none" }}
//                     onClick={() => setNewItem(p => ({ ...p, adjustment: "0.000" }))}>
//                     <i className="fa-solid fa-xmark text-danger"></i>
//                   </button>
//                 )}
//               </div>
//               {/* <small className="text-muted d-block text-center mt-1">
//                 Current: {parseFloat(newItem.adjustment || 0).toFixed(3)}g
//               </small> */}
//             </div>
//             <div className="col-md-1">
//               <label>Purity (%)</label>
//               <input type="text" className="form-control" value={newItem.purity}
//                 onChange={e => {
//                   const v = e.target.value;
//                   if (/^\d*\.?\d{0,3}$/.test(v) || v === "") {
//                     const num = parseFloat(v);
//                     if (!v || num <= 100) setNewItem({ ...newItem, purity: v });
//                   }
//                 }} />
//             </div>
//             <div className="col-md-1">
//               <label>Pure (g)</label>
//               <input type="text" className="form-control" value={newItem.pure} readOnly />
//             </div>
//             <div className="col-md-1 p-4">
//               {editingItemId === null ? (
//                 <button className="btn btn-success btn-sm" onClick={handleAddItem}><i className="bi bi-plus"></i></button>
//               ) : (
//                 <button className="btn btn-info btn-sm" onClick={handleUpdateItem}><i className="bi bi-check"></i></button>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="row mt-2">
//           <div className="col-lg-9">
//             <div className="card p-2">
//               <h6>Item List</h6>
//               <table className="table table-sm">
//                 <thead className="bg-light">
//                   <tr>
//                     <th>S.No</th>
//                     <th>Item</th>
//                     <th>Qty</th>
//                     <th>Cat</th>
//                     <th>Type</th>
//                     <th>Weight</th>
//                     <th>Purity</th>
//                     <th>Pure</th>
//                     <th>Adj</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {formData.items.map((item, i) => (
//                     <tr key={item.id}>
//                       <td>{i + 1}</td>
//                       <td>{item.item}{item.other_name && ` (${item.other_name})`}</td>
//                       <td>{item.quantity}</td>
//                       <td>{item.category}</td>
//                       <td>{item.type || "-"}</td>
//                       <td>{parseFloat(item.weight).toFixed(3)}</td>
//                       <td>{parseFloat(item.purity).toFixed(2)}%</td>
//                       <td>{parseFloat(item.pure).toFixed(3)}</td>
//                       <td className="text-end">
//                         <span className={item.adjustment > 0 ? "text-success" : item.adjustment < 0 ? "text-danger" : ""}>
//                           {item.adjustment > 0 ? "+" : ""}{parseFloat(item.adjustment || 0).toFixed(3)}
//                         </span>
//                       </td>
//                       <td>
//                         <button className="btn btn-sm btn-light" onClick={() => handleEditItem(item.id)}><i className="fa-solid fa-pen-to-square text-primary"></i></button>
//                         <button className="btn btn-sm btn-light" onClick={() => handleRemoveItem(item.id)}><i className="fa-solid fa-trash text-danger"></i></button>
//                       </td>
//                     </tr>
//                   ))}
//                   {formData.items.length === 0 && <tr><td colSpan="10" className="text-center">No items</td></tr>}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           <div className="col-lg-3">
//             <div className="card p-3">
//               <div className="row mb-2"><div className="col-6">Total Pure (g)</div><div className="col-6"><input className="form-control" value={formData.total_pure} readOnly /></div></div>
//               <div className="row mb-2"><div className="col-6">Return Type</div><div className="col-6">
//                 <select className="form-select" value={formData.return_type} onChange={e => setFormData({ ...formData, return_type: e.target.value, pure: "", amount: "", enter_amount: "" })}>
//                   <option value="">Select</option>
//                   <option value="Pure">Pure</option>
//                   <option value="Amount">Amount</option>
//                 </select>
//               </div></div>

//               {formData.return_type === "Amount" && (
//                 <>
//                   <div className="row mb-2"><div className="col-6"><strong>Enter Amount (₹)</strong></div><div className="col-6"><input className="form-control" value={formData.enter_amount || "0.00"} readOnly /></div></div>
//                   <div className="row mb-2"><div className="col-6">Paid (₹)</div><div className="col-6">
//                     <input type="text" className="form-control" value={formData.amount} onChange={e => /^\d*\.?\d*$/.test(e.target.value) && setFormData({ ...formData, amount: e.target.value })} />
//                   </div></div>
//                 </>
//               )}

//               {formData.return_type === "Pure" && (
//                 <div className="row mb-2"><div className="col-6">Return Pure (g)</div><div className="col-6">
//                   <input type="text" className="form-control" value={formData.pure} onChange={e => /^\d*\.?\d*$/.test(e.target.value) && setFormData({ ...formData, pure: e.target.value })} />
//                 </div></div>
//               )}

//               <div className="row mb-2"><div className="col-6">Opening (g)</div><div className="col-6"><input className="form-control" value={formData.opening} readOnly /></div></div>
//               <div className="row mb-2"><div className="col-6">Current (g)</div><div className="col-6"><input className="form-control" value={formData.current} readOnly /></div></div>
//               <div className="row mb-2"><div className="col-6">Closing (g)</div><div className="col-6"><input className="form-control" value={formData.close} readOnly /></div></div>

//               <div className="d-flex justify-content-between mt-3">
//                 <button className="btn btn-secondary btn-sm" onClick={() => navigate("/retailers")}>Back</button>
//                 <button className="btn btn-danger btn-sm" onClick={() => navigate("/retailers")}>Clear</button>
//                 <button className="btn btn-primary btn-sm" onClick={handlePrint} disabled={loading}>Print</button>
//                 <button className="btn btn-success btn-sm" onClick={handleSave} disabled={loading}>Save</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {showModal && (
//         <>
//           <div className="modal fade show" style={{ display: "block" }}>
//             <div className="modal-dialog modal-dialog-centered">
//               <div className="modal-content">
//                 <div className="modal-header"><h6>Print Confirmation</h6><button className="btn-close" onClick={() => setShowModal(false)}></button></div>
//                 <div className="modal-body text-center">
//                   <p>Do you want to print the retailer bill?</p>
//                   <button className="btn btn-secondary mx-2" onClick={() => navigate("/retailers")}>Cancel</button>
//                   <button className="btn btn-primary" onClick={() => { setShowModal(false); navigate(`/retailer-bill/${formData.retailer_id}`); }}>Print</button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="modal-backdrop fade show"></div>
//         </>
//       )}
//     </>
//   );
// }

// export default UpdateRetailer;



import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ApiUrl from "../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext";

function UpdateRetailer({ toggleSidebar }) {
  const { id } = useParams();
  const toast = useToast();
  const navigate = useNavigate();
   const location = useLocation();
  const [navSource, setNavSource] = useState(null); // NEW
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
  const [retailers, setRetailers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRetailer, setSelectedRetailer] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [editingItemId, setEditingItemId] = useState(null);
  const [generateNumber, setGenerateNumber] = useState("");
  const [userdata, setUserdata] = useState([]);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedStaff, setSelectedStaff] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [isManagerLocked, setIsManagerLocked] = useState(false);
  const [isStaffLocked, setIsStaffLocked] = useState(false);
  const [adjustmentInput, setAdjustmentInput] = useState("");

  const [formData, setFormData] = useState({
    retailer_id: "",
    retailer_date: "",
    retailer_details_id: "",
    return_type: "",
    enter_amount: "",
    amount: "",
    pure: "",
    opening: "0.000",
    current: "0.000",
    close: "0.000",
    total_pure: "0.000",
    manager: "",
    manager_name: "",
    staff: "",
    items: [],
    retailer_details: {
      retailer_id: "",
      name: null,
      mobile: null,
      address: null,
    },
  });

  const [newItem, setNewItem] = useState({
    item: "",
    category: "",
    other_name: "",
    type: "",
    item_name_english: "",
    item_name_tamil: "",
    quantity: 1,
    weight: "",
    purity: "",
    pure: "0.000",
    total_amount: "0.000",
    adjustment: "0.000",
  });

  useEffect(() => {
    if (toggleSidebar) toggleSidebar();
    fetchUserData();
    fetchLoggedInUser();
    fetchInitialData();
  }, [id]);

    useEffect(() => {
      if (location.state?.source === "blue-page") {
        setNavSource({
          selectedRowId: location.state.selectedRowId,
          returnTab: location.state.returnTab,
        });
      }
    }, [location.state]);
  
    const goBackToOrigin = () => {
      if (navSource) {
        navigate("/balance/blue-page-balance", { // ⬅ swap in your actual route path for BluePageBalance
          state: {
            from: "balance-page",
            selectedRowId: navSource.selectedRowId,
            returnTab: navSource.returnTab,
          },
        });
      } else {
        navigate("/retailers");
      }
    };

const fetchInitialData = async () => {
  try {
    setLoading(true);

    const [productResponse, retailerResponse, retailerDetailsResponse] = await Promise.all([
      axios.get(`${ApiUrl}/Api/product.php`),
      axios.get(`${ApiUrl}/Api/retailer.php`),
      axios.get(`${ApiUrl}/Api/retailer_details.php?id=${id}`),
    ]);

    setProducts(productResponse.data?.data || []);
    const retailerList = retailerResponse.data?.data || [];
    setRetailers(retailerList);

    const detailsArr = retailerDetailsResponse.data?.data || [];
    const data = Array.isArray(detailsArr) ? detailsArr[0] : detailsArr;

    if (data) {
      setGenerateNumber(data.retailer_id || "");

      const mappedItems = (data.items || []).map((item, index) => ({
        id: index + 1,
        item: item.item || "",
        other_name: item.other_name || "",
        category: item.category || "",
        type: item.type || "",
        item_name_english: item.item_name_english || item.item || "",
        item_name_tamil: item.item_name_tamil || "",
        quantity: parseFloat(item.quantity) || 1,
        weight: parseFloat(item.weight) || 0,
        purity: parseFloat(item.percentage) || 0,
        pure: parseFloat(item.pure) || 0,
        total_amount: parseFloat(item.total_amount) || 0,
        adjustment: parseFloat(item.adjustment) || 0,
      }));

      setFormData({
        retailer_id: data.retailer_id || "",
        retailer_date: data.retailer_date || new Date().toISOString().split("T")[0],
        retailer_details_id: data.supplier_id || "",
        return_type: data.return_type || "",
        enter_amount: data.enter_amount || "",
        amount: data.amount || "",
        pure: data.pure || "0",
        opening: parseFloat(data.opening || 0).toFixed(3),
        current: parseFloat(data.current || 0).toFixed(3),
        close: parseFloat(data.close || 0).toFixed(3),
        total_pure: parseFloat(data.total_pure || 0).toFixed(3),
        manager: data.manager || "",
        manager_name: data.manager_name || "",
        staff: data.staff || "",
        items: mappedItems,
        retailer_details: data.retailer_details || {
          retailer_id: "",
          name: null,
          mobile: null,
          address: null,
        },
      });

      // Pre-fill retailer search
      if (data.supplier_id) {
        const matchedRetailer = retailerList.find(r => r.retailer_id === data.supplier_id);
        if (matchedRetailer) {
          setSelectedRetailer(matchedRetailer);
          setSearchTerm(`${matchedRetailer.retailer_id} - ${matchedRetailer.name}`);
        } else {
          const rd = data.retailer_details;
          setSearchTerm(`${data.supplier_id}${rd?.name ? " - " + rd.name : ""}`);
        }
      }

      // Pre-fill manager
      if (data.manager) {
        setSelectedManager(data.manager_name || data.manager);
      }

      // Pre-fill staff
      if (data.staff) {
        setSelectedStaff(data.staff);
      }
    }
  } catch (error) {
    console.error("Initialization error:", error);
    toast.error("Failed to initialize form data", 3000, "topRight");
  } finally {
    setLoading(false);
  }
};

  // Pure calculation for new item
  useEffect(() => {
    let pure = "0.000";
    let total_amount = "0.000";

    if (newItem.weight && newItem.purity && newItem.quantity) {
      const weight = parseFloat(newItem.weight) || 0;
      const purity = parseFloat(newItem.purity) || 0;
      const quantity = parseFloat(newItem.quantity) || 1;

      if (purity > 100) {
        toast.error("Purity cannot exceed 100%", 3000, "topRight");
        setNewItem(prev => ({ ...prev, purity: "" }));
        return;
      }

      const singlePure = (weight * purity) / 100;
      let calculatedPure = quantity * singlePure;
      calculatedPure += parseFloat(newItem.adjustment) || 0;

      pure = calculatedPure.toFixed(3);
      total_amount = (quantity * singlePure).toFixed(3);
    }

    setNewItem(prev => ({ ...prev, pure, total_amount }));
  }, [newItem.weight, newItem.purity, newItem.quantity, newItem.adjustment]);

  // Total pure
  useEffect(() => {
    const totalPure = formData.items.reduce((sum, item) => sum + parseFloat(item.pure || 0), 0).toFixed(3);
    setFormData(prev => ({ ...prev, total_pure: totalPure }));
  }, [formData.items]);


  // Filter products based on selected category
useEffect(() => {
  if (newItem.category) {
    const filtered = products.filter(product => 
      product.category === newItem.category
    );
    setFilteredProducts(filtered);
  } else {
    setFilteredProducts([]);
  }
}, [newItem.category, products]);

  // Current calculation
  useEffect(() => {
    const opening = parseFloat(formData.opening) || 0;
    let current = opening;

    if (formData.return_type === "Amount") {
      current += parseFloat(formData.enter_amount) || 0;
    } else if (formData.return_type === "Pure") {
      current += parseFloat(formData.total_pure) || 0;
    }

    setFormData(prev => ({ ...prev, current: current.toFixed(3) }));
  }, [formData.opening, formData.total_pure, formData.enter_amount, formData.return_type]);

  // Closing calculation
  useEffect(() => {
    const current = parseFloat(formData.current) || 0;
    let close = current;

    if (formData.return_type === "Pure") {
      close -= parseFloat(formData.pure) || 0;
    } else if (formData.return_type === "Amount") {
      close -= parseFloat(formData.amount) || 0;
    }

    setFormData(prev => ({ ...prev, close: close.toFixed(3) }));
  }, [formData.current, formData.pure, formData.amount, formData.return_type]);

  // Simplified opening balance
  const fetchOpeningBalance = async (retailerId) => {
    if (!retailerId || !formData.return_type) {
      setFormData(prev => ({ ...prev, opening: "0.000" }));
      return;
    }

    try {
      const res = await axios.get(`${ApiUrl}/Api/retailer_details.php`);
      const all = res.data?.data || [];

      const relevant = all
        .filter(r => r.retailer_details_id === retailerId && r.return_type === formData.return_type)
        .sort((a, b) => new Date(b.retailer_date) - new Date(a.retailer_date));

      const opening = relevant.length > 0 ? parseFloat(relevant[0].close || 0).toFixed(3) : "0.000";
      setFormData(prev => ({ ...prev, opening }));
    } catch (err) {
      setFormData(prev => ({ ...prev, opening: "0.000" }));
    }
  };

  useEffect(() => {
    if (selectedRetailer?.retailer_id) {
      fetchOpeningBalance(selectedRetailer.retailer_id);
    }
  }, [selectedRetailer, formData.return_type]);

  const handleSelectRetailer = async (retailer) => {
    setSelectedRetailer(retailer);
    setSearchTerm(`${retailer.retailer_id} - ${retailer.name}`);
    setFormData(prev => ({
      ...prev,
      retailer_details_id: retailer.retailer_id,
      retailer_details: { ...retailer },
      opening: "0.000",
    }));
    setShowDropdown(false);
    await fetchOpeningBalance(retailer.retailer_id);
  };

  const clearRetailer = () => {
    setSelectedRetailer(null);
    setSearchTerm("");
    setFormData(prev => ({
      ...prev,
      retailer_details_id: "",
      retailer_details: { retailer_id: "", name: null, mobile: null, address: null },
      opening: "0.000",
    }));
  };

  const validateItem = () => {
    if (!newItem.item) return toast.error("Select item", 3000, "topRight"), false;
    if (!newItem.category) return toast.error("Select category", 3000, "topRight"), false;
    if (newItem.item !== "Bar" && !newItem.type) return toast.error("Select type", 3000, "topRight"), false;
    if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) return toast.error("Valid quantity required", 3000, "topRight"), false;
    if (!newItem.weight || parseFloat(newItem.weight) <= 0) return toast.error("Valid weight required", 3000, "topRight"), false;
    if (!newItem.purity || parseFloat(newItem.purity) <= 0 || parseFloat(newItem.purity) > 100) return toast.error("Valid purity (0-100%)", 3000, "topRight"), false;
    if (newItem.item === "Others" && !newItem.other_name) return toast.error("Enter name for Others", 3000, "topRight"), false;
    return true;
  };

const handleAddItem = () => {
  if (!validateItem()) return;
  const newItems = [...formData.items, { 
    ...newItem, 
    id: formData.items.length + 1,
    item_name_english: newItem.item_name_english || newItem.item,
    item_name_tamil: newItem.item_name_tamil || "",
  }];
  setFormData(prev => ({ ...prev, items: newItems }));
  resetNewItem();
};

const handleUpdateItem = () => {
  if (!validateItem() || editingItemId === null) return;
  const updated = formData.items.map(item =>
    item.id === editingItemId ? { 
      ...newItem, 
      id: item.id,
      item_name_english: newItem.item_name_english || newItem.item,
      item_name_tamil: newItem.item_name_tamil || "",
    } : item
  );
  setFormData(prev => ({ ...prev, items: updated }));
  resetNewItem();
};
const handleEditItem = (id) => {
  const item = formData.items.find(i => i.id === id);
  if (item) {
    setNewItem({ 
      ...item, 
      quantity: item.quantity.toString(), 
      weight: item.weight.toString(), 
      purity: item.purity.toString(),
      item_name_english: item.item_name_english || item.item,
      item_name_tamil: item.item_name_tamil || "",
    });
    setAdjustmentInput("");
    setEditingItemId(id);
  }
};

  const handleRemoveItem = (id) => {
    const filtered = formData.items.filter(i => i.id !== id).map((i, idx) => ({ ...i, id: idx + 1 }));
    setFormData(prev => ({ ...prev, items: filtered }));
  };

const resetNewItem = () => {
  setNewItem({
    item: "", 
    category: "", 
    other_name: "", 
    type: "",
    item_name_english: "",
    item_name_tamil: "",
    quantity: 1,
    weight: "", 
    purity: "", 
    pure: "0.000", 
    total_amount: "0.000", 
    adjustment: "0.000"
  });
  setAdjustmentInput("");
  setEditingItemId(null);
};

  const validateForm = () => {
    if (!formData.retailer_details_id) return toast.error("Select retailer", 3000, "topRight"), false;
    if (formData.items.length === 0) return toast.error("Add at least one item", 3000, "topRight"), false;
    if (!formData.return_type) return toast.error("Select return type", 3000, "topRight"), false;
    if (formData.return_type === "Pure" && parseFloat(formData.pure) <= 0) return toast.error("Enter valid pure return", 3000, "topRight"), false;
    if (formData.return_type === "Amount" && (!formData.amount || parseFloat(formData.amount) <= 0)) return toast.error("Enter valid paid amount", 3000, "topRight"), false;
    if (!formData.manager) return toast.error("Select manager", 3000, "topRight"), false;
    const currentRole = JSON.parse(localStorage.getItem("user") || "{}").role || "";
    const isAdminRole = currentRole === "Admin" || currentRole === "admin";
    if (!isAdminRole && !formData.staff) return toast.error("Select staff", 3000, "topRight"), false;
    return true;
  };

  const preparePayload = () => {
    const payload = {
      id,
      retailer_id: formData.retailer_id,
      retailer_date: formData.retailer_date,
      retailer_details_id: formData.retailer_details_id,
      supplier_id: formData.retailer_details_id, // Add this for backward compatibility with API
      return_type: formData.return_type,
      enter_amount: parseFloat(formData.enter_amount) || 0,
      amount: parseFloat(formData.amount) || 0,
      paid: parseFloat(formData.amount) || 0, // Add this for backward compatibility
      pure: parseFloat(formData.pure) || 0,
      opening: parseFloat(formData.opening) || 0,
      current: parseFloat(formData.current) || 0,
      close: parseFloat(formData.close) || 0,
      total_pure: parseFloat(formData.total_pure) || 0,
      manager: formData.manager || "",
      manager_name: formData.manager_name || "",
      staff: formData.staff || "",
      items: formData.items.map(i => ({
        category: i.category,
        quantity: i.quantity,
        item: i.item,
        weight: i.weight,
        type: i.type || "",
        other_name: i.other_name || "",
        percentage: i.purity,
        pure: i.pure,
        total_amount: i.total_amount,
        adjustment: i.adjustment,
      })),
    };

    if (formData.return_type === "Pure") {
      payload.enter_amount = 0;
      payload.amount = 0;
      payload.paid = 0;
    } else if (formData.return_type === "Amount") {
      payload.pure = 0;
    }

    return payload;
  };

  const handleSave = async () => {
    if (!validateForm()) return;
    try {
      setLoading(true);
      const payload = preparePayload();
      await axios.put(`${ApiUrl}/Api/retailer_details.php/${id}`, payload);
      toast.success("Retailer updated!", 3000, "topRight");
      navigate("/retailers");
    } catch (err) {
      toast.error(err.response?.data?.message || "Update failed", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = async () => {
    if (!validateForm()) return;
    try {
      setLoading(true);
      const payload = preparePayload();
      await axios.put(`${ApiUrl}/Api/retailer_details.php/${id}`, payload);
      toast.success("Updated for print", 3000, "topRight");
      navigate(`/retailer-bill/${formData.retailer_id}`);
    } catch (err) {
      toast.error("Print failed", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  const fetchLoggedInUser = () => {
    try {
      const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
      if (userInfo?.user_id) setLoggedInUser(userInfo);
    } catch (error) {
      console.error("Error reading user:", error);
    }
  };

  const fetchUserData = async () => {
    try {
      const res = await axios.get(`${ApiUrl}/Api/user.php`);
      setUserdata(Array.isArray(res.data.data) ? res.data.data : []);
    } catch (err) {
      toast.error("Failed to load staff data", 3000, "topRight");
    }
  };

  useEffect(() => {
    if (!loggedInUser || userdata.length === 0) return;
    const currentUser = userdata.find(u => u.user_id === loggedInUser.user_id);
    if (!currentUser) return;

    if (currentUser.role.toLowerCase() === "manager") {
      setSelectedManager(currentUser.id.toString());
      setIsManagerLocked(true);
      const allStaff = userdata.filter(u => u.role.toLowerCase() === "employee");
      setStaffList(allStaff);
      setFormData(prev => ({ ...prev, manager: currentUser.user_id, manager_name: currentUser.name }));
    } else if (currentUser.role.toLowerCase() === "employee") {
      // Employee: staff auto-filled & locked, manager is FREE dropdown (pick who is on duty)
      setSelectedStaff(currentUser.name);
      setIsStaffLocked(true);
      setFormData(prev => ({ ...prev, staff: currentUser.name }));
      const allStaff = userdata.filter(u => u.role.toLowerCase() === "employee");
      setStaffList(allStaff);
    }
    // Admin: only manager dropdown, no staff
  }, [loggedInUser, userdata]);

  const handleManagerChange = (e) => {
    if (isManagerLocked) return;
    const managerId = e.target.value;
    setSelectedManager(managerId);
    if (managerId) {
      const managerObj = userdata.find(u => u.id === parseInt(managerId));
      if (managerObj) {
        const allStaff = userdata.filter(u => u.role.toLowerCase() === "employee");
        setStaffList(allStaff);
        setFormData(prev => ({ ...prev, manager: managerObj.user_id, manager_name: managerObj.name }));
      }
    } else {
      setFormData(prev => ({ ...prev, manager: "", manager_name: "" }));
    }
  };

  const handleStaffChange = (e) => {
    if (isStaffLocked) return;
    const staffName = e.target.value;
    setSelectedStaff(staffName);
    setFormData(prev => ({ ...prev, staff: staffName }));
  };

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}

      <div className="container-fluid py-2">
        <div className="row">
          <div className="col-lg-3">
            <div className="card p-2">
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">Retailer No</label>
                  <input type="text" className="form-control" value={generateNumber} readOnly />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={formData.retailer_date}
                    onChange={(e) => setFormData(prev => ({ ...prev, retailer_date: e.target.value }))}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-9">
            <div className="card p-2">
              <div className="row g-3">
                <div className="col-md-3 position-relative">
                  <label className="form-label">Retailer</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search retailer..."
                      value={searchTerm}
                      onChange={(e) => { setSearchTerm(e.target.value); setShowDropdown(true); }}
                      onFocus={() => setShowDropdown(true)}
                    />
                    {searchTerm && (
                      <button className="btn btn-outline-secondary" type="button" style={{height:"35px"}} onClick={clearRetailer}>
                        <i className="bi bi-x"></i>
                      </button>
                    )}
                  </div>
                  {showDropdown && retailers.length > 0 && (
                    <div className="dropdown-menu show w-100">
                      {retailers
                        .filter(s => s.retailer_id.toLowerCase().includes(searchTerm.toLowerCase()) || s.name.toLowerCase().includes(searchTerm.toLowerCase()))
                        .map(s => (
                          <button key={s.retailer_id} className="dropdown-item" onClick={() => handleSelectRetailer(s)} type="button">
                            {s.retailer_id} - {s.name}
                          </button>
                        ))}
                    </div>
                  )}
                </div>
                <div className="col-md-3">
                  <label className="form-label">Retailer Name</label>
                  <input type="text" className="form-control" value={formData.retailer_details?.name || ""} disabled style={{ backgroundColor: "#f0f0f0" }} />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Mobile</label>
                  <input type="text" className="form-control" value={formData.retailer_details?.mobile || ""} disabled style={{ backgroundColor: "#f0f0f0" }} />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Address</label>
                  <input type="text" className="form-control" value={formData.retailer_details?.address || ""} disabled style={{ backgroundColor: "#f0f0f0" }} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          {(() => {
            const role = JSON.parse(localStorage.getItem("user") || "{}").role || "";
            const isAdmin = role === "Admin" || role === "admin";
            return (
              <>
                <div className="col-md-3">
                  <label className="form-label">Manager <span className="text-danger">*</span></label>
                  <select className="form-select" value={selectedManager} onChange={handleManagerChange} disabled={isManagerLocked}>
                    <option value="">Select Manager</option>
                    {userdata.filter(u => u.role.toLowerCase() === "manager").map(m => (
                      <option key={m.id} value={m.id}>{m.name}</option>
                    ))}
                  </select>
                </div>
                {!isAdmin && (
                  <div className="col-md-3">
                    <label className="form-label">Staff</label>
                    <select className="form-select" value={selectedStaff} onChange={handleStaffChange} disabled={isStaffLocked}>
                      <option value="">Select Staff</option>
                      {staffList.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                    </select>
                  </div>
                )}
              </>
            );
          })()}
        </div>

        <div className="card p-2 mt-1">
          <div className="row g-3">
            <div className="col-md-2">
              <label>Item</label>
              <select className="form-select" value={newItem.item} onChange={e => setNewItem({ ...newItem, item: e.target.value, type: e.target.value === "Bar" ? "" : newItem.type })}>
                <option value="">Select</option>
                <option value="Bar">Bar</option>
                <option value="Jewels">Jewels</option>
                <option value="Others">Others</option>
              </select>
            </div>
            {newItem.item === "Others" && (
              <div className="col-md-2">
                <label>Others Name</label>
                <input type="text" className="form-control" value={newItem.other_name} onChange={e => setNewItem({ ...newItem, other_name: e.target.value })} />
              </div>
            )}
            <div className="col-md-2">
              <label>Category</label>
              <select className="form-select" value={newItem.category} onChange={e => setNewItem({ ...newItem, category: e.target.value })}>
                <option value="">Select</option>
                <option value="Gold">Gold</option>
                <option value="Silver">Silver</option>
                <option value="Gold Coin">Gold Coin</option>
                <option value="Silver Coin">Silver Coin</option>
              </select>
            </div>
            {/* Item Name dropdown - shows items from products table */}
<div className="col-md-2">
  <label>Item Name</label>
  <select 
    className="form-select" 
    value={newItem.item_name_english || ""} 
    onChange={(e) => {
      const selectedValue = e.target.value;
      const selected = filteredProducts.find(p => 
        (p.item_name_english || p.item_name) === selectedValue
      );
      setNewItem({
        ...newItem,
        item_name_english: selectedValue,
        item_name_tamil: selected?.item_name_tamil || "",
        type: selectedValue, // Keep for backward compatibility
      });
    }}
    disabled={!newItem.category || newItem.item === "Bar"}
  >
    <option value="">Select Item Name</option>
    {filteredProducts.map((product) => {
      const displayName = product.item_name_tamil 
        ? `${product.item_name_english || product.item_name} / ${product.item_name_tamil}`
        : (product.item_name_english || product.item_name);
      return (
        <option key={product.id} value={product.item_name_english || product.item_name}>
          {displayName}
        </option>
      );
    })}
  </select>
  {!newItem.category && filteredProducts.length === 0 && (
    <small className="text-muted">Please select category first</small>
  )}
</div>
            <div className="col-md-1">
              <label>Weight (g)</label>
              <input type="text" className="form-control" value={newItem.weight} onChange={e => /^\d*\.?\d*$/.test(e.target.value) && setNewItem({ ...newItem, weight: e.target.value })} />
            </div>
            <div className="col-md-2 position-relative">
              <label>Adjustment</label>
              <div className="input-group">
                <button className="btn btn-outline-danger btn-sm" type="button" style={{height:"30px"}} onClick={() => {
                  const v = parseFloat(adjustmentInput) || 0;
                  if (v > 0) { setNewItem(p => ({ ...p, adjustment: (parseFloat(p.adjustment || 0) - v).toFixed(3) })); setAdjustmentInput(""); }
                }}><i className="fa-solid fa-minus"></i></button>
                <input type="text" className="form-control form-control-sm text-center" value={adjustmentInput} placeholder="0.000"
                  onChange={e => /^\d*\.?\d*$/.test(e.target.value) && setAdjustmentInput(e.target.value)}
                  onKeyPress={e => e.key === "Enter" && (parseFloat(adjustmentInput) || 0) > 0 && (setNewItem(p => ({ ...p, adjustment: (parseFloat(p.adjustment || 0) + parseFloat(adjustmentInput)).toFixed(3) })), setAdjustmentInput(""))} />
                <button className="btn btn-outline-success btn-sm" type="button" style={{height:"30px"}} onClick={() => {
                  const v = parseFloat(adjustmentInput) || 0;
                  if (v > 0) { setNewItem(p => ({ ...p, adjustment: (parseFloat(p.adjustment || 0) + v).toFixed(3) })); setAdjustmentInput(""); }
                }}><i className="fa-solid fa-plus"></i></button>
                {parseFloat(newItem.adjustment || 0) !== 0 && (
                  <button className="btn btn-sm position-absolute end-0 top-50 translate-middle-y me-1" style={{ zIndex: 10, background: "none", border: "none" }}
                    onClick={() => setNewItem(p => ({ ...p, adjustment: "0.000" }))}>
                    <i className="fa-solid fa-xmark text-danger"></i>
                  </button>
                )}
              </div>
            </div>
            <div className="col-md-1">
              <label>Purity (%)</label>
              <input type="text" className="form-control" value={newItem.purity}
                onChange={e => {
                  const v = e.target.value;
                  if (/^\d*\.?\d{0,3}$/.test(v) || v === "") {
                    const num = parseFloat(v);
                    if (!v || num <= 100) setNewItem({ ...newItem, purity: v });
                  }
                }} />
            </div>
            <div className="col-md-1">
              <label>Pure (g)</label>
              <input type="text" className="form-control" value={newItem.pure} readOnly />
            </div>
            <div className="col-md-1 p-4">
              {editingItemId === null ? (
                <button className="btn btn-success btn-sm" onClick={handleAddItem}><i className="bi bi-plus"></i></button>
              ) : (
                <button className="btn btn-info btn-sm" onClick={handleUpdateItem}><i className="bi bi-check"></i></button>
              )}
            </div>
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-lg-9">
            <div className="card p-2">
              <h6>Item List</h6>
              <table className="table table-sm">
                <thead className="bg-light">
                  <tr>
                    <th>S.No</th>
                    <th>Item</th>
                    <th>Qty</th>
                    <th>Cat</th>
                    <th>ItemName</th>
                    <th>Weight</th>
                    <th>Purity</th>
                    <th>Pure</th>
                    <th>Adjustment</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.items.map((item, i) => (
                    <tr key={item.id}>
                      <td>{i + 1}</td>
                      <td>
                        {item.item_name_tamil
                          ? `${item.item_name_english || item.item} / ${item.item_name_tamil}`
                          : (item.item_name_english || item.item)}
                        {item.other_name && ` (${item.other_name})`}
                      </td>
                      <td>{item.quantity}</td>
                      <td>{item.category}</td>
                      <td>
  {item.item_name_tamil
    ? `${item.item_name_english || item.item} / ${item.item_name_tamil}`
    : (item.item_name_english || item.item)}
  {item.other_name && ` (${item.other_name})`}
</td>
                      <td>{parseFloat(item.weight).toFixed(3)}</td>
                      <td>{parseFloat(item.purity).toFixed(2)}%</td>
                      <td>{parseFloat(item.pure).toFixed(3)}</td>
                      <td className="text-start">
                        <span className={item.adjustment > 0 ? "text-success" : item.adjustment < 0 ? "text-danger" : ""}>
                          {item.adjustment > 0 ? "+" : ""}{parseFloat(item.adjustment || 0).toFixed(3)}
                        </span>
                      </td>
                      <td>
                        <button className="btn btn-sm btn-light" onClick={() => handleEditItem(item.id)}><i className="fa-solid fa-pen-to-square text-primary"></i></button>
                        <button className="btn btn-sm btn-light" onClick={() => handleRemoveItem(item.id)}><i className="fa-solid fa-trash text-danger"></i></button>
                      </td>
                    </tr>
                  ))}
                  {formData.items.length === 0 && <tr><td colSpan="10" className="text-center">No items</td></tr>}
                </tbody>
              </table>
            </div>
          </div>

          <div className="col-lg-3">
            <div className="card p-3">
              <div className="row mb-2"><div className="col-6">Total Pure (g)</div><div className="col-6"><input className="form-control" value={formData.total_pure} readOnly /></div></div>
              <div className="row mb-2"><div className="col-6">Return Type</div><div className="col-6">
                <select className="form-select" value={formData.return_type} onChange={e => setFormData({ ...formData, return_type: e.target.value, pure: "", amount: "", enter_amount: "" })}>
                  <option value="">Select</option>
                  <option value="Pure">Pure</option>
                  <option value="Amount">Amount</option>
                </select>
              </div></div>

              {formData.return_type === "Amount" && (
                <>
                  <div className="row mb-2"><div className="col-6"><strong>Enter Amount (₹)</strong></div><div className="col-6"><input className="form-control" value={formData.enter_amount || "0.00"} readOnly /></div></div>
                  <div className="row mb-2"><div className="col-6">Paid (₹)</div><div className="col-6">
                    <input type="text" className="form-control" value={formData.amount} onChange={e => /^\d*\.?\d*$/.test(e.target.value) && setFormData({ ...formData, amount: e.target.value })} />
                  </div></div>
                </>
              )}

              {formData.return_type === "Pure" && (
                <div className="row mb-2"><div className="col-6">Return Pure (g)</div><div className="col-6">
                  <input type="text" className="form-control" value={formData.pure} onChange={e => /^\d*\.?\d*$/.test(e.target.value) && setFormData({ ...formData, pure: e.target.value })} />
                </div></div>
              )}

              <div className="row mb-2"><div className="col-6">Opening (g)</div><div className="col-6"><input className="form-control" value={formData.opening} readOnly /></div></div>
              <div className="row mb-2"><div className="col-6">Current (g)</div><div className="col-6"><input className="form-control" value={formData.current} readOnly /></div></div>
              <div className="row mb-2"><div className="col-6">Closing (g)</div><div className="col-6"><input className="form-control" value={formData.close} readOnly /></div></div>

              <div className="d-flex justify-content-between mt-3">
                    <button className="btn btn-secondary btn-sm" onClick={goBackToOrigin}>
  <i className="fa-solid fa-arrow-left"></i> Back
</button>
                <button className="btn btn-danger btn-sm" onClick={() => navigate("/retailers")}>Clear</button>
                <button className="btn btn-primary btn-sm" onClick={handlePrint} disabled={loading}>Print</button>
                <button className="btn btn-success btn-sm" onClick={handleSave} disabled={loading}>Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header"><h6>Print Confirmation</h6><button className="btn-close" onClick={() => setShowModal(false)}></button></div>
                <div className="modal-body text-center">
                  <p>Do you want to print the retailer bill?</p>
                  <button className="btn btn-secondary mx-2" onClick={() => navigate("/retailers")}>Cancel</button>
                  <button className="btn btn-primary" onClick={() => { setShowModal(false); navigate(`/retailer-bill/${formData.retailer_id}`); }}>Print</button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
}

export default UpdateRetailer;